export default [
  {
    "name": "navbar",
    "title": "Шапка",
    "id": "nav-001",
    "list": [
      {
        "id": "7eba976e-b242-4750-9db1-c301cd737e42",
        "name": "navbar",
        "title": "Классическая",
        "component": "header",
        "preview": "https://sitebypro-server.ru/static/files/blocks/header.png",
        "data": [
          {
            "id": "36b265e0-43be-4841-8ddd-aacdbd93dcb3",
            "number": 0,
            "type": 9,
            "title": "Внешний контейнер для nav--main",
            "description": "Обёртка, центрирует и ограничивает ширину навигации",
            "data": "",
            "tag": "div",
            "classes": [
              "nav--outer"
            ],
            "settings": {
              "display": "flex",
              "justifyContent": "center",
              "alignItems": "center",
              "width": "100%",
              "padding": "0 1rem",
              "backgroundColor": "rgb(0, 0, 0)",
              "responsive": {
                "480": {
                  "padding": "0 1rem",
                  "backgroundColor": "transparent"
                },
                "768": {
                  "padding": "0 1rem",
                  "backgroundColor": "transparent"
                },
                "1245": {}
              }
            },
            "children": {
              "id": "ece39df7-a2eb-4f07-a0c7-8a639ce5086b",
              "data": [
                {
                  "id": "09309a1d-01d5-4acb-9b18-aea3715c277e",
                  "number": 0,
                  "type": 8,
                  "title": "Контейнер nav",
                  "description": "Главный контейнер навигационного бара",
                  "data": "",
                  "tag": "div",
                  "classes": [
                    "nav",
                    "nav--main"
                  ],
                  "settings": {
                    "justifyContent": "space-between",
                    "alignItems": "center",
                    "display": "flex",
                    "flexFlow": "row",
                    "margin": "auto",
                    "padding": "1rem",
                    "width": "100%",
                    "maxWidth": "1800px",
                    "backgroundColor": "rgb(0, 0, 0)",
                    "responsive": {
                      "480": {
                        "padding": "1rem",
                        "display": "flex",
                        "flexFlow": "row",
                        "justifyContent": "space-between",
                        "alignItems": "flex-start",
                        "flexDirection": "column",
                        "textAlign": "left",
                        "flexWrap": "nowrap",
                        "backgroundColor": "transparent"
                      },
                      "768": {
                        "padding": "1rem",
                        "display": "flex",
                        "flexFlow": "row",
                        "justifyContent": "space-between",
                        "alignItems": "flex-start",
                        "flexDirection": "column",
                        "textAlign": "left",
                        "flexWrap": "nowrap",
                        "backgroundColor": "transparent"
                      },
                      "1245": {}
                    }
                  },
                  "children": {
                    "id": "4205ff4a-f980-492b-ab58-022a08c220cf",
                    "data": [
                      {
                        "id": "7e4873fa-199f-48c4-9ba9-6c8ac1018de1",
                        "number": 1,
                        "title": "Логотип",
                        "description": "Лого Студия маникюра",
                        "data": "",
                        "tag": "div",
                        "classes": [
                          "nav__logo"
                        ],
                        "settings": {
                          "width": "2rem",
                          "height": "2rem",
                          "marginRight": "1rem",
                          "backgroundImage": "url(\"https://sitebypro-server.ru/static/files/60d46060-6e53-4339-bbd0-1f37098aa81b.svg\")",
                          "backgroundSize": "contain",
                          "backgroundRepeat": "no-repeat",
                          "backgroundPosition": "center",
                          "responsive": {
                            "480": {
                              "width": "4rem",
                              "height": "4rem"
                            },
                            "768": {
                              "width": "4rem",
                              "height": "4rem"
                            },
                            "1245": {}
                          }
                        }
                      },
                      {
                        "id": "40024763-e7f1-486f-97a4-25a2ee011305",
                        "number": 2,
                        "title": "Меню навигации",
                        "description": "Семантический список навигации с пунктами: Услуги, Галерея, Цены, О нас",
                        "data": "",
                        "tag": "div",
                        "classes": [
                          "nav__list"
                        ],
                        "settings": {
                          "display": "flex",
                          "gap": "0.5rem",
                          "flexDirection": "row",
                          "flexWrap": "nowrap",
                          "alignItems": "center",
                          "responsive": {
                            "480": {
                              "display": "flex",
                              "flexFlow": "row",
                              "justifyContent": "flex-start",
                              "alignItems": "flex-start",
                              "gap": "0.5rem",
                              "marginTop": "1rem",
                              "flexDirection": "column",
                              "textAlign": "left"
                            },
                            "768": {
                              "display": "flex",
                              "flexFlow": "row",
                              "justifyContent": "flex-start",
                              "alignItems": "flex-start",
                              "gap": "0.5rem",
                              "marginTop": "1rem",
                              "flexDirection": "column",
                              "textAlign": "left"
                            },
                            "1248": {}
                          }
                        },
                        "children": {
                          "id": "533e4b55-7749-4457-b7cf-579d9b9fcef3",
                          "data": [
                            {
                              "id": "57d37907-0cab-44fb-883a-4885ec3fe78b",
                              "number": 1,
                              "title": "Пункт меню — Услуги",
                              "description": "Ссылка на раздел услуг",
                              "data": "",
                              "tag": "p",
                              "classes": [
                                "nav__item"
                              ],
                              "children": {
                                "id": "fb874c64-6171-4b65-9964-7119a7c15d2f",
                                "data": [
                                  {
                                    "id": "012888ad-6a3b-43f7-8d53-5ba48259a621",
                                    "number": 0,
                                    "title": "Ссылка — Услуги",
                                    "description": "Текст ссылки",
                                    "data": "Услуги",
                                    "tag": "p",
                                    "classes": [
                                      "nav__link"
                                    ],
                                    "settings": {
                                      "cursor": "pointer",
                                      "responsive": {
                                        "480": {
                                          "fontSize": "1.5rem"
                                        },
                                        "768": {
                                          "fontSize": "1.5rem"
                                        },
                                        "1245": {}
                                      }
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              "id": "f1601c9f-afb8-496b-9e26-380e252069ed",
                              "number": 2,
                              "title": "Пункт меню — Галерея",
                              "description": "Ссылка на галерею работ",
                              "data": "",
                              "tag": "p",
                              "classes": [
                                "nav__item"
                              ],
                              "children": {
                                "id": "5b20f85b-9c51-4a08-9c34-7e40220e94a1",
                                "data": [
                                  {
                                    "id": "fb8a4a18-607c-4f9c-a146-677d7f16a4ea",
                                    "number": 0,
                                    "title": "Ссылка — Галерея",
                                    "description": "Текст ссылки",
                                    "data": "Галерея",
                                    "tag": "p",
                                    "classes": [
                                      "nav__link"
                                    ],
                                    "settings": {
                                      "cursor": "pointer",
                                      "responsive": {
                                        "480": {
                                          "fontSize": "1.5rem"
                                        },
                                        "768": {
                                          "fontSize": "1.5rem"
                                        },
                                        "1245": {}
                                      }
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              "id": "28233e02-5506-45d4-8243-27e2a6003dd6",
                              "number": 3,
                              "title": "Пункт меню — Цены",
                              "description": "Ссылка на страницу цен",
                              "data": "",
                              "tag": "p",
                              "classes": [
                                "nav__item"
                              ],
                              "children": {
                                "id": "d67a1758-74f0-4404-8e25-b03b5dd8b1ac",
                                "data": [
                                  {
                                    "id": "0bd6afec-9ada-4422-8686-d48ffa859c45",
                                    "number": 0,
                                    "title": "Ссылка — Цены",
                                    "description": "Текст ссылки",
                                    "data": "Цены",
                                    "tag": "p",
                                    "classes": [
                                      "nav__link"
                                    ],
                                    "settings": {
                                      "cursor": "pointer",
                                      "responsive": {
                                        "480": {
                                          "fontSize": "1.5rem"
                                        },
                                        "768": {
                                          "fontSize": "1.5rem"
                                        },
                                        "1245": {}
                                      }
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              "id": "d0679f60-124d-47c2-88e5-7276012d050b",
                              "number": 4,
                              "title": "Пункт меню — О нас",
                              "description": "Ссылка на страницу о салоне",
                              "data": "",
                              "tag": "p",
                              "classes": [
                                "nav__item"
                              ],
                              "children": {
                                "id": "cf82b1fe-2ab0-483f-a71b-081cce8f647e",
                                "data": [
                                  {
                                    "id": "920f6733-3694-4c73-b9f5-ae7727951d8b",
                                    "number": 0,
                                    "title": "Ссылка — О нас",
                                    "description": "Текст ссылки",
                                    "data": "О нас",
                                    "tag": "p",
                                    "classes": [
                                      "nav__link"
                                    ],
                                    "settings": {
                                      "cursor": "pointer",
                                      "responsive": {
                                        "480": {
                                          "fontSize": "1.5rem"
                                        },
                                        "768": {
                                          "fontSize": "1.5rem"
                                        },
                                        "1245": {}
                                      }
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        "id": "bab181e4-935d-4789-a067-6c0d8ff0a563",
                        "number": 3,
                        "title": "Контакты / телефон",
                        "description": "Телефон для быстрой связи",
                        "data": "+7 (999) 123-45-67",
                        "tag": "p",
                        "classes": [
                          "nav__phone"
                        ],
                        "settings": {
                          "marginLeft": "auto",
                          "marginRight": "0.5rem",
                          "cursor": "pointer",
                          "responsive": {
                            "480": {
                              "fontSize": "1.5rem",
                              "marginLeft": "0",
                              "marginTop": "2rem",
                              "marginRight": "auto",
                              "marginBottom": "1rem"
                            },
                            "768": {
                              "fontSize": "1.5rem",
                              "marginLeft": "0",
                              "marginTop": "2rem",
                              "marginRight": "auto",
                              "marginBottom": "1rem"
                            },
                            "1248": {}
                          }
                        }
                      },
                      {
                        "id": "0f561100-2f34-4bfc-9ded-fa183d2b7cef",
                        "number": 4,
                        "title": "CTA — Записаться",
                        "description": "Кнопка призыва к действию для записи на услугу",
                        "data": "Записаться",
                        "tag": "button",
                        "classes": [
                          "nav__cta",
                          "btn",
                          "btn--primary"
                        ],
                        "settings": {
                          "responsive": {
                            "480": {},
                            "768": {},
                            "1245": {
                              "margin": "0rem 0rem 0rem 1rem",
                              "flexWrap": "nowrap",
                              "flexDirection": "row",
                              "justifyContent": "center",
                              "alignItems": "center",
                              "gap": "0.5rem",
                              "padding": "0.5rem 1rem 0.5rem 1rem",
                              "letterSpacing": 0,
                              "lineHeight": 1,
                              "fontSize": 1
                            },
                            "1248": {}
                          },
                          "flexDirection": "row"
                        },
                        "children": {
                          "id": "5610922a-2035-4d74-b390-1cedef07c98b",
                          "data": [
                            {
                              "id": "c94ff921-14e2-449c-bf13-61ac8538d72c",
                              "number": 1,
                              "tag": "i",
                              "title": "Иконка",
                              "classes": [
                                "icon",
                                "far fa-calendar-alt"
                              ],
                              "data": [],
                              "settings": {}
                            }
                          ]
                        },
                        "action": {
                          "id": "26c7bd7d-9b83-479f-b5ad-1c0fa1608bb9",
                          "name": "Открыть диаологовое окно",
                          "slug": "open-modal",
                          "functionName": "openModal",
                          "data": [
                            {
                              "type": "input",
                              "id": "cd184930-abf2-40db-893c-591450f20055",
                              "value": "Записаться на прием",
                              "placeholder": "Заголовок",
                              "label": "Заголовок"
                            },
                            {
                              "type": "input",
                              "id": "2a0c8282-0c10-4181-8b59-8dcea0ffee08",
                              "value": "Отмена",
                              "placeholder": "Отмена",
                              "label": "Кнопка"
                            },
                            {
                              "type": "input",
                              "id": "1dd4c44d-00dd-40c3-98fb-2f457ac89c72",
                              "value": "Записаться",
                              "placeholder": "Сохранить",
                              "label": "Кнопка"
                            },
                            {
                              "type": "p",
                              "id": "4a3a1a5b-f210-4061-8f69-54ce1b131702",
                              "value": "Укажите ваши данные",
                              "label": "Параграф / описание",
                              "placeholder": "Например - Ссылка на сайт"
                            },
                            {
                              "type": "input",
                              "id": "6de4a180-ccb8-4bf0-98c0-80cee358aac6",
                              "value": "ФИО",
                              "placeholder": "Например - Укажите ваше ФИО",
                              "label": "Текстовый ввод"
                            },
                            {
                              "type": "p",
                              "id": "ea70e210-8697-41bb-928e-9fa97e857953",
                              "value": "Выберите дату для записи",
                              "label": "Параграф / описание",
                              "placeholder": "Например - Введите пароль"
                            },
                            {
                              "type": "datetime",
                              "id": "70508d6f-701d-4cec-9fac-e0b9f716b07f",
                              "value": false,
                              "label": "Выбор даты/времени",
                              "placeholder": "Например - Дата рождения"
                            },
                            {
                              "type": "p",
                              "id": "4b77e403-2833-47cb-874e-3680f99bc86c",
                              "value": "Добавьте желаемый дизайн",
                              "label": "Параграф / описание",
                              "placeholder": "Например - Дата рождения"
                            },
                            {
                              "type": "file",
                              "id": "c174b264-e39e-46cc-b1c4-112ab2f9a3b0",
                              "value": "",
                              "label": "Загрузка файлов",
                              "placeholder": "Например - Дата рождения"
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    ]
  },
  {
    "name": "hero",
    "title": "Текстовые блоки",
    "id": "hero-001",
    "list": [
      {
        "id": "64s7edd2-5b4d-4aec-8941-117569502d27",
        "name": "hero",
        "title": "Основной заголовок",
        "component": "uni",
        "preview": "https://sitebypro-server.ru/static/files/blocks/title.png",
        "data": [
          {
            "id": "0f6e7101-473e-4272-904c-709ae13a9d67",
            "number": 0,
            "type": 8,
            "title": "Контейнер hero",
            "description": "Фон с текстурой, центрированная колонка; адаптивная верстка для разных экранов",
            "data": "",
            "tag": "div",
            "classes": [
              "hero",
              "hero--adaptive"
            ],
            "settings": {
              "display": "flex",
              "justifyContent": "flex-start",
              "alignItems": "center",
              "flexDirection": "row",
              "flexWrap": "nowrap",
              "responsive": {
                "480": {
                  "margin": "0rem 0rem 0rem 0rem",
                  "padding": "1rem"
                },
                "768": {
                  "margin": "0rem 0rem 0rem 0rem",
                  "padding": "3rem"
                },
                "1245": {
                  "margin": "0rem 0rem 0rem 0rem",
                  "padding": "3rem"
                }
              },
              "backgroundColor": "rgb(251, 135, 158)"
            },
            "children": {
              "id": "52f5497f-2626-429c-aad0-2cb0de8042b4",
              "data": [
                {
                  "id": "ca2g6a61-084e-4ff9-b402-0cfc90f83e45",
                  "number": 1,
                  "title": "Крупный заголовок (многострочный)",
                  "description": "Основной большой текст — адаптивные размеры и переносы",
                  "data": "Услуги",
                  "tag": "h1",
                  "classes": [
                    "hero__title"
                  ],
                  "settings": {
                    "color": "black",
                    "fontSize": "3rem",
                    "lineHeight": "1",
                    "fontWeight": "700",
                    "letterSpacing": "0.02rem",
                    "textAlign": "left",
                    "display": "flex",
                    "maxWidth": "1800px",
                    "margin": "auto",
                    "width": "100%",
                    "responsive": {
                      "480": {
                        "fontSize": 3.2,
                        "padding": "0rem 0rem 0rem 0rem",
                        "flexDirection": "row",
                        "justifyContent": "flex-start",
                        "alignItems": "stretch",
                        "flexWrap": "nowrap",
                        "lineHeight": 1,
                        "letterSpacing": 0
                      },
                      "768": {
                        "fontSize": 4.5,
                        "padding": "0rem 0rem 0rem 0rem",
                        "flexDirection": "row",
                        "justifyContent": "flex-start",
                        "alignItems": "stretch",
                        "flexWrap": "nowrap",
                        "lineHeight": 1,
                        "letterSpacing": 0
                      },
                      "1245": {
                        "flexDirection": "row",
                        "justifyContent": "flex-start",
                        "alignItems": "stretch",
                        "flexWrap": "nowrap",
                        "padding": "0rem 0rem 0rem 0rem",
                        "fontSize": 5,
                        "lineHeight": 1,
                        "letterSpacing": 0.1
                      }
                    },
                    "font": {
                      "family": "kucheryavy",
                      "variants": [
                        "regular"
                      ],
                      "subsets": [
                        "cyrillic",
                        "latin"
                      ],
                      "version": "v1",
                      "lastModified": "2025-09-21",
                      "files": {
                        "regular": "https://sitebypro-server.ru/fonts/kucheryavy/Kucheryavy.otf"
                      },
                      "category": "sans-serif",
                      "kind": "webfonts#webfont",
                      "menu": "https://sitebypro-server.ru/fonts/kucheryavy/Kucheryavy.otf",
                      "format": "otf",
                      "url": "https://sitebypro-server.ru/fonts/kucheryavy/Kucheryavy.otf"
                    }
                  }
                }
              ]
            }
          }
        ]
      },
      {
        "id": "64s7edd2-5b4d-4aec-8941-117569502d27",
        "name": "hero",
        "title": "Основной параграф",
        "component": "uni",
        "preview": "https://sitebypro-server.ru/static/files/blocks/paragraph.png",
        "data": [
          {
            "id": "0f6e7101-473e-4272-904c-709ae13a9d67",
            "number": 0,
            "type": 8,
            "title": "Контейнер hero",
            "description": "Фон с текстурой, центрированная колонка; адаптивная верстка для разных экранов",
            "data": "",
            "tag": "div",
            "classes": [
              "hero",
              "hero--adaptive"
            ],
            "settings": {
              "display": "flex",
              "justifyContent": "flex-start",
              "alignItems": "center",
              "flexDirection": "row",
              "flexWrap": "nowrap",
              "responsive": {
                "480": {
                  "margin": "0rem 0rem 0rem 0rem",
                  "padding": "1rem"
                },
                "768": {
                  "margin": "0rem 0rem 0rem 0rem",
                  "padding": "3rem"
                },
                "1245": {
                  "margin": "0rem 0rem 0rem 0rem",
                  "padding": "3rem"
                }
              },
              "backgroundColor": "rgb(251, 135, 158)"
            },
            "children": {
              "id": "52f5497f-2626-429c-aad0-2cb0de8042b4",
              "data": [
                {
                  "id": "ca2g6a61-084e-4ff9-b402-0cfc90f83e45",
                  "number": 1,
                  "title": "Текст (многострочный)",
                  "description": "Основной текст",
                  "data": "Услуги",
                  "tag": "h1",
                  "classes": [
                    "hero__title"
                  ],
                  "settings": {
                    "color": "black",
                    "fontSize": "3rem",
                    "lineHeight": "1",
                    "fontWeight": "100",
                    "letterSpacing": "0.02rem",
                    "textAlign": "left",
                    "display": "flex",
                    "maxWidth": "1800px",
                    "margin": "auto",
                    "width": "100%",
                    "responsive": {
                      "480": {
                        "fontSize": 1,
                        "padding": "0rem 0rem 0rem 0rem",
                        "flexDirection": "row",
                        "justifyContent": "flex-start",
                        "alignItems": "stretch",
                        "flexWrap": "nowrap",
                        "lineHeight": 1,
                        "letterSpacing": 0
                      },
                      "768": {
                        "fontSize": 1,
                        "padding": "0rem 0rem 0rem 0rem",
                        "flexDirection": "row",
                        "justifyContent": "flex-start",
                        "alignItems": "stretch",
                        "flexWrap": "nowrap",
                        "lineHeight": 1,
                        "letterSpacing": 0
                      },
                      "1245": {
                        "flexDirection": "row",
                        "justifyContent": "flex-start",
                        "alignItems": "stretch",
                        "flexWrap": "nowrap",
                        "padding": "0rem 0rem 0rem 0rem",
                        "fontSize": 2,
                        "lineHeight": 1,
                        "letterSpacing": 0.1
                      }
                    },
                    "font": null
                  }
                }
              ]
            }
          }
        ]
      }
    ]
  },
  {
    "name": "product",
    "title": "Карточка продукта",
    "id": "product-001",
    "list": [
      {
        "id": "b23b17d9-eef7-47b2-8d72-c837741195a0",
        "name": "product-card",
        "title": "Большое изображение",
        "component": "uni",
        "preview": "https://sitebypro-server.ru/static/files/blocks/big_img.png",
        "data": [
          {
            "id": "52835d73-713d-4a9b-8c0e-e36857a4779e",
            "number": 0,
            "type": 8,
            "title": "Обёртка продукта",
            "description": "Нужна для центрирования блока product--detail",
            "tag": "div",
            "classes": [
              "product-wrapper"
            ],
            "settings": {
              "display": "flex",
              "justifyContent": "center",
              "width": "100%",
              "backgroundColor": "#fb879e",
              "margin": "auto",
              "responsive": {
                "480": {},
                "768": {},
                "1245": {
                  "padding": "0rem 0rem 0rem 0rem",
                  "flexWrap": "nowrap"
                }
              }
            },
            "children": {
              "id": "d342c1c6-be0f-49a6-9515-0a3b06a69264",
              "data": [
                {
                  "id": "e598d081-1522-489e-9ae3-45307b30d3aa",
                  "number": 0,
                  "type": 8,
                  "title": "Обёртка продукта",
                  "description": "Нужна для центрирования блока product--detail",
                  "tag": "div",
                  "classes": [
                    "product-wrapper"
                  ],
                  "settings": {
                    "display": "flex",
                    "justifyContent": "center",
                    "width": "100%",
                    "backgroundColor": "#fb879e",
                    "margin": "auto",
                    "responsive": {
                      "480": {},
                      "768": {},
                      "1245": {
                        "padding": "0rem 0rem 0rem 0rem",
                        "flexWrap": "nowrap",
                        "alignItems": "stretch",
                        "flexDirection": "row"
                      }
                    }
                  },
                  "children": {
                    "id": "8f3fc416-93a7-40ca-a32b-ee0f17a218d9",
                    "data": [
                      {
                        "id": "2ef40b76-c6c3-40dc-8dec-55d060a9d8cb",
                        "number": 0,
                        "type": 8,
                        "title": "Контейнер продукта",
                        "description": "Трехколоночный контейнер: левый текст, центр — банка, правый — описание и характеристики; становится колонкой на мобильных",
                        "tag": "div",
                        "classes": [
                          "product",
                          "product--detail"
                        ],
                        "settings": {
                          "display": "flex",
                          "flexDirection": "row",
                          "justifyContent": "space-between",
                          "alignItems": "flex-start",
                          "flexWrap": "nowrap",
                          "paddingTop": 4,
                          "paddingRight": 3,
                          "paddingBottom": 4,
                          "paddingLeft": 3,
                          "width": "100%",
                          "margin": "3rem",
                          "maxWidth": "1800px",
                          "height": "30rem",
                          "backgroundImage": "url('https://sitebypro-server.ru/static/files/a359b2d8-4cf9-4261-a85b-8a17067a11c3.png')",
                          "borderRadius": "1rem",
                          "backgroundSize": "cover",
                          "backgroundPosition": "50% 80%",
                          "backgroundRepeat": "no-repeat",
                          "responsive": {
                            "480": {
                              "flexDirection": "column",
                              "paddingTop": 1.5,
                              "paddingRight": 1.5,
                              "paddingBottom": 1.5,
                              "paddingLeft": 1.5,
                              "height": "23rem",
                              "margin": "1rem"
                            },
                            "768": {
                              "flexDirection": "column",
                              "paddingTop": 1.5,
                              "paddingRight": 1.5,
                              "paddingBottom": 1.5,
                              "paddingLeft": 1.5,
                              "height": "25rem"
                            },
                            "1245": {
                              "padding": "0rem 0rem 0rem 0rem"
                            }
                          }
                        },
                        "children": {
                          "id": "794db48f-bc08-41a1-816b-b9126eed0b3b",
                          "data": [
                            {
                              "id": "e2ce2a02-c2ed-4322-8e1a-e40a72c5222c",
                              "number": 1,
                              "title": "Левая колонка — ключевые тексты",
                              "description": "Название, процент алкоголя, ингредиенты",
                              "data": "",
                              "tag": "div",
                              "classes": [
                                "product__left"
                              ],
                              "settings": {
                                "display": "flex",
                                "flexDirection": "column",
                                "justifyContent": "flex-start",
                                "alignItems": "flex-start",
                                "width": "100%",
                                "height": "100%",
                                "position": "relative",
                                "responsive": {
                                  "480": {
                                    "width": "100%",
                                    "marginBottom": 2,
                                    "alignItems": "center",
                                    "textAlign": "center"
                                  },
                                  "768": {
                                    "width": "100%",
                                    "marginBottom": 2,
                                    "alignItems": "center",
                                    "textAlign": "center"
                                  },
                                  "1245": {
                                    "padding": "0rem 0rem 0rem 0rem",
                                    "flexWrap": "nowrap"
                                  }
                                }
                              },
                              "children": {
                                "id": "953a77a6-725d-44b8-b78f-675487238e38",
                                "data": [
                                  {
                                    "id": "2f012325-fc9c-42b3-9a41-18a0794e9e99",
                                    "number": 1,
                                    "title": "Название — NEIPA",
                                    "description": "Крупный декоративный заголовок",
                                    "data": "Маникюр",
                                    "tag": "h1",
                                    "classes": [
                                      "product__title"
                                    ],
                                    "settings": {
                                      "color": "rgb(255, 255, 255)",
                                      "fontSize": 5,
                                      "lineHeight": 1,
                                      "fontWeight": 700,
                                      "textAlign": "left",
                                      "display": "block",
                                      "responsive": {
                                        "480": {
                                          "fontSize": 3.2,
                                          "textAlign": "center"
                                        },
                                        "768": {
                                          "fontSize": 4.5,
                                          "textAlign": "center"
                                        },
                                        "1245": {
                                          "padding": "0rem 0rem 0rem 0rem",
                                          "flexWrap": "nowrap",
                                          "letterSpacing": 0,
                                          "alignItems": "stretch",
                                          "justifyContent": "flex-start",
                                          "margin": "auto 0rem 0rem 0rem",
                                          "flexDirection": "row"
                                        }
                                      },
                                      "font": {
                                        "family": "kucheryavy",
                                        "variants": [
                                          "regular"
                                        ],
                                        "subsets": [
                                          "latin"
                                        ],
                                        "version": "v1",
                                        "files": {
                                          "regular": "https://sitebypro-server.ru/fonts/kucheryavy/Kucheryavy.otf"
                                        },
                                        "category": "sans-serif"
                                      }
                                    }
                                  },
                                  {
                                    "id": "c29d0919-0ea8-44f7-acfb-5fa572b40ede",
                                    "number": 2,
                                    "title": "Описание",
                                    "description": "Малый текст с информацией об алкоголе",
                                    "data": "На все случаи жизни",
                                    "tag": "p",
                                    "classes": [
                                      "product__alc"
                                    ],
                                    "settings": {
                                      "color": "#f2f2f2",
                                      "fontSize": 1.5,
                                      "lineHeight": 1.2,
                                      "marginTop": 0.5,
                                      "textAlign": "left",
                                      "responsive": {
                                        "480": {
                                          "textAlign": "center"
                                        },
                                        "768": {
                                          "textAlign": "center"
                                        },
                                        "1245": {}
                                      }
                                    }
                                  },
                                  {
                                    "id": "c243a838-3ef2-42f9-ae99-cb540b0ddd00",
                                    "number": 3,
                                    "title": "CTA — Заказать",
                                    "description": "Кнопка заказа/добавления в корзину",
                                    "data": "Записаться",
                                    "tag": "button",
                                    "classes": [
                                      "product__btn",
                                      "btn",
                                      "btn--accent"
                                    ],
                                    "settings": {
                                      "paddingTop": 1,
                                      "paddingRight": 1.5,
                                      "paddingBottom": 1,
                                      "paddingLeft": 1.5,
                                      "borderRadius": 2,
                                      "fontSize": 1.2,
                                      "marginTop": "auto",
                                      "flexDirection": "row",
                                      "backgroundColor": "black",
                                      "color": "#ffffff",
                                      "responsive": {
                                        "480": {
                                          "width": "",
                                          "textAlign": "center",
                                          "justifyContent": "center",
                                          "padding": "0rem 0rem 0rem 0rem",
                                          "flexWrap": "nowrap"
                                        },
                                        "768": {
                                          "width": "",
                                          "padding": "0rem 0rem 0rem 0rem",
                                          "flexWrap": "nowrap",
                                          "justifyContent": "center"
                                        },
                                        "1245": {
                                          "padding": "0rem 0rem 0rem 0rem",
                                          "flexWrap": "nowrap",
                                          "gap": "0.5rem",
                                          "letterSpacing": 0,
                                          "alignItems": "stretch",
                                          "lineHeight": 1,
                                          "justifyContent": "flex-start",
                                          "position": "absolute",
                                          "right": "0",
                                          "bottom": "0"
                                        }
                                      }
                                    },
                                    "children": {
                                      "id": "902a7508-9b96-40a9-966c-810705d4059a",
                                      "data": [
                                        {
                                          "id": "8ea119e7-0216-4fdd-a7e1-90f1099b857f",
                                          "number": 1,
                                          "tag": "i",
                                          "title": "Иконка",
                                          "classes": [
                                            "icon",
                                            "far fa-arrow-alt-circle-right"
                                          ],
                                          "data": [],
                                          "settings": {}
                                        }
                                      ]
                                    },
                                    "action": {
                                      "id": "37aa29e9-3680-4a3f-b404-d1c492292585",
                                      "name": "Открыть диаологовое окно",
                                      "slug": "open-modal",
                                      "functionName": "openModal",
                                      "data": [
                                        {
                                          "type": "input",
                                          "id": "050a28f1-af1f-486c-a11b-2ea3e8b659d7",
                                          "value": "Записаться на прием",
                                          "placeholder": "Заголовок",
                                          "label": "Заголовок"
                                        },
                                        {
                                          "type": "input",
                                          "id": "2c55ff74-398b-4be3-9614-f87db217a2d8",
                                          "value": "Отмена",
                                          "placeholder": "Отмена",
                                          "label": "Кнопка"
                                        },
                                        {
                                          "type": "input",
                                          "id": "a5538111-e574-4dfe-904e-a0107d5b4abd",
                                          "value": "Записаться",
                                          "placeholder": "Сохранить",
                                          "label": "Кнопка"
                                        },
                                        {
                                          "type": "p",
                                          "id": "5c7a5b4b-13f4-423c-a8ec-aa5974328e54",
                                          "value": "Укажите ваши данные",
                                          "label": "Параграф / описание",
                                          "placeholder": "Например - Введите пароль"
                                        },
                                        {
                                          "type": "input",
                                          "id": "d4c85c4e-7c0b-4ad7-a5be-bbfa089c275a",
                                          "value": "ФИО",
                                          "placeholder": "Например - Укажите ваше ФИО",
                                          "label": "Текстовый ввод"
                                        },
                                        {
                                          "type": "p",
                                          "id": "dac510a9-fc5c-4806-abb8-e4c095a40fe1",
                                          "value": "Выберите дату и время",
                                          "label": "Параграф / описание",
                                          "placeholder": "Например - Номер телефона"
                                        },
                                        {
                                          "type": "datetime",
                                          "id": "ce9c8b82-424e-4d00-b212-6a9eb539949a",
                                          "value": "",
                                          "label": "Выбор даты/времени",
                                          "placeholder": "Например - Введите пароль"
                                        },
                                        {
                                          "type": "p",
                                          "id": "757a5436-9294-422c-bcc9-cf0219d6ec14",
                                          "value": "Добавьте желаемый дизайн",
                                          "label": "Параграф / описание",
                                          "placeholder": "Например - Введите пароль"
                                        },
                                        {
                                          "type": "file",
                                          "id": "045d524b-b4d3-4d33-b379-8ffd8bfcc034",
                                          "value": "",
                                          "label": "Загрузка файлов",
                                          "placeholder": "Например - Ссылка на сайт"
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      },
      {
        "id": "b23bs7d9-eef7-47b2-8d72-c837741195a0",
        "name": "product-card",
        "title": "Парное изображение",
        "component": "uni",
        "preview": "https://sitebypro-server.ru/static/files/blocks/two_blocks.png",
        "data": [
          {
            "id": "52235d73-713d-4a9b-8c0e-e36857a4779e",
            "number": 0,
            "type": 8,
            "title": "Обёртка продукта",
            "description": "Нужна для центрирования блока product--detail",
            "tag": "div",
            "classes": [
              "product-wrapper"
            ],
            "settings": {
              "display": "flex",
              "justifyContent": "center",
              "width": "100%",
              "gap": "3rem",
              "margin": "auto",
              "backgroundColor": "rgb(251 135 158)",
              "responsive": {
                "480": {},
                "768": {},
                "1245": {}
              }
            },
            "children": {
              "id": "d342f1c6-be0f-49a6-9515-0a3b06a69264",
              "data": [
                {
                  "id": "16f55009-7717-4266-adac-3bd380ab6c17",
                  "number": 0,
                  "type": 8,
                  "title": "Обёртка продукта",
                  "description": "Нужна для центрирования блока product--detail",
                  "tag": "div",
                  "classes": [
                    "product-wrapper"
                  ],
                  "settings": {
                    "display": "flex",
                    "justifyContent": "center",
                    "width": "100%",
                    "gap": "1rem",
                    "maxWidth": "calc(1800px + 6rem)",
                    "backgroundColor": "rgb(251 135 158)",
                    "responsive": {
                      "480": {
                        "padding": "0rem 0rem 1rem 0rem"
                      },
                      "768": {
                        "padding": "0rem 0rem 1rem 0rem"
                      },
                      "1245": {
                        "padding": "0rem 0rem 3rem 0rem",
                        "flexWrap": "nowrap",
                        "gap": "3rem"
                      }
                    }
                  },
                  "children": {
                    "id": "cec3f546-6d91-42e9-9ee6-184f5feba9ba",
                    "data": [
                      {
                        "id": "d8d065e2-a9b7-487b-a5c1-f11f54ee3013",
                        "number": 0,
                        "type": 8,
                        "title": "Контейнер продукта",
                        "description": "Трехколоночный контейнер: левый текст, центр — банка, правый — описание и характеристики; становится колонкой на мобильных",
                        "tag": "div",
                        "classes": [
                          "product",
                          "product--detail"
                        ],
                        "settings": {
                          "display": "flex",
                          "flexDirection": "row",
                          "justifyContent": "space-between",
                          "alignItems": "flex-start",
                          "flexWrap": "nowrap",
                          "paddingTop": 4,
                          "paddingRight": 3,
                          "paddingBottom": 4,
                          "paddingLeft": 3,
                          "width": "100%",
                          "maxWidth": "1800px",
                          "height": "30rem",
                          "backgroundImage": "url(\"https://sitebypro-server.ru/static/files/75c225a7-71db-45aa-bc1d-3e6a2344f8e4.png\")",
                          "borderRadius": "1rem",
                          "backgroundSize": "cover",
                          "backgroundPosition": "50% 80%",
                          "backgroundRepeat": "no-repeat",
                          "margin": "0rem 0rem 0rem 3rem",
                          "position": "relative",
                          "responsive": {
                            "480": {
                              "flexDirection": "column",
                              "paddingTop": 1.5,
                              "paddingRight": 1.5,
                              "paddingBottom": 1.5,
                              "paddingLeft": 1.5,
                              "height": "23rem",
                              "margin": "0rem 0rem 0rem 1rem"
                            },
                            "768": {
                              "flexDirection": "column",
                              "paddingTop": 1.5,
                              "paddingRight": 1.5,
                              "paddingBottom": 1.5,
                              "paddingLeft": 1.5,
                              "height": "25rem"
                            },
                            "1245": {
                              "padding": "0rem 0rem 0rem 0rem"
                            }
                          }
                        },
                        "children": {
                          "id": "a1acbadc-1018-40b4-9441-ca06742fb951",
                          "data": [
                            {
                              "id": "64ad35a9-9a8d-4314-bc6f-7fe983572152",
                              "number": 1,
                              "title": "Левая колонка — ключевые тексты",
                              "description": "Название, процент алкоголя, ингредиенты",
                              "data": "",
                              "tag": "div",
                              "classes": [
                                "product__left"
                              ],
                              "settings": {
                                "display": "flex",
                                "flexDirection": "column",
                                "justifyContent": "flex-start",
                                "alignItems": "flex-start",
                                "width": "100%",
                                "height": "100%",
                                "responsive": {
                                  "480": {
                                    "width": "100%",
                                    "marginBottom": 2,
                                    "alignItems": "flex-start",
                                    "textAlign": "left"
                                  },
                                  "768": {
                                    "width": "100%",
                                    "marginBottom": 2,
                                    "alignItems": "flex-start",
                                    "textAlign": "left"
                                  },
                                  "1245": {
                                    "padding": "0rem 0rem 0rem 0rem",
                                    "flexWrap": "nowrap"
                                  }
                                }
                              },
                              "children": {
                                "id": "aa8294cf-3b9d-454f-8f3e-341257810001",
                                "data": [
                                  {
                                    "id": "e9cd6708-8815-466c-8e87-4f2d46887a8f",
                                    "number": 1,
                                    "title": "Название — NEIPA",
                                    "description": "Крупный декоративный заголовок",
                                    "data": "Педикюр",
                                    "tag": "h1",
                                    "classes": [
                                      "product__title"
                                    ],
                                    "settings": {
                                      "color": "rgb(255, 255, 255)",
                                      "fontSize": 5,
                                      "lineHeight": 1,
                                      "fontWeight": 700,
                                      "textAlign": "left",
                                      "display": "block",
                                      "responsive": {
                                        "480": {
                                          "fontSize": 3,
                                          "textAlign": "left"
                                        },
                                        "768": {
                                          "fontSize": 3.5,
                                          "textAlign": "left"
                                        },
                                        "1245": {
                                          "padding": "0rem 0rem 0rem 0rem",
                                          "flexWrap": "nowrap",
                                          "letterSpacing": 0,
                                          "alignItems": "stretch",
                                          "justifyContent": "flex-start",
                                          "flexDirection": "row",
                                          "margin": "0rem 0rem 0rem 0rem"
                                        }
                                      },
                                      "font": {
                                        "family": "kucheryavy",
                                        "variants": [
                                          "regular"
                                        ],
                                        "subsets": [
                                          "latin"
                                        ],
                                        "version": "v1",
                                        "files": {
                                          "regular": "https://sitebypro-server.ru/fonts/kucheryavy/Kucheryavy.otf"
                                        },
                                        "category": "sans-serif"
                                      }
                                    }
                                  },
                                  {
                                    "id": "4f4c0092-3898-4f9c-8f54-f64175898048",
                                    "number": 2,
                                    "title": "Описание",
                                    "description": "Малый текст с информацией об алкоголе",
                                    "data": "Для здоровья и красоты стоп",
                                    "tag": "p",
                                    "classes": [
                                      "product__alc"
                                    ],
                                    "settings": {
                                      "color": "#f2f2f2",
                                      "fontSize": 1.5,
                                      "lineHeight": 1.2,
                                      "textAlign": "left",
                                      "responsive": {
                                        "480": {
                                          "textAlign": "left"
                                        },
                                        "768": {
                                          "textAlign": "left"
                                        },
                                        "1245": {
                                          "width": "15rem",
                                          "marginTop": "0.5rem"
                                        }
                                      }
                                    }
                                  },
                                  {
                                    "id": "c242a838-3ef2-4239-ae99-cb540b0ddd00",
                                    "number": 3,
                                    "title": "CTA — Заказать",
                                    "description": "Кнопка заказа/добавления в корзину",
                                    "data": "Записаться",
                                    "tag": "button",
                                    "classes": [
                                      "product__btn",
                                      "btn",
                                      "btn--accent"
                                    ],
                                    "settings": {
                                      "paddingTop": 1,
                                      "paddingRight": 1.5,
                                      "paddingBottom": 1,
                                      "paddingLeft": 1.5,
                                      "borderRadius": 2,
                                      "fontSize": 1.2,
                                      "marginTop": "auto",
                                      "backgroundColor": "black",
                                      "color": "#ffffff",
                                      "responsive": {
                                        "480": {
                                          "width": "",
                                          "textAlign": "center",
                                          "justifyContent": "center",
                                          "padding": "0rem 0rem 0rem 0rem",
                                          "flexWrap": "nowrap"
                                        },
                                        "768": {
                                          "width": "",
                                          "padding": "0rem 0rem 0rem 0rem",
                                          "flexWrap": "nowrap",
                                          "justifyContent": "center"
                                        },
                                        "1245": {
                                          "padding": "0rem 0rem 0rem 0rem",
                                          "flexWrap": "nowrap",
                                          "gap": "0.5rem",
                                          "flexDirection": "row",
                                          "letterSpacing": 0,
                                          "alignItems": "stretch",
                                          "lineHeight": 1,
                                          "justifyContent": "flex-start"
                                        }
                                      },
                                      "flexDirection": "row"
                                    },
                                    "children": {
                                      "id": "902a7508-9b96-40a9-966c-810705d4059a",
                                      "data": [
                                        {
                                          "id": "8ea119e7-0216-4fdd-a7e1-90f1099b857f",
                                          "number": 1,
                                          "tag": "i",
                                          "title": "Иконка",
                                          "classes": [
                                            "icon",
                                            "far fa-arrow-alt-circle-right"
                                          ],
                                          "data": [],
                                          "settings": {}
                                        }
                                      ]
                                    },
                                    "action": {
                                      "id": "37aa29e9-3680-4a3f-b404-d1c492292585",
                                      "name": "Открыть диаологовое окно",
                                      "slug": "open-modal",
                                      "functionName": "openModal",
                                      "data": [
                                        {
                                          "type": "input",
                                          "id": "050a28f1-af1f-486c-a11b-2ea3e8b659d7",
                                          "value": "Записаться на прием",
                                          "placeholder": "Заголовок",
                                          "label": "Заголовок"
                                        },
                                        {
                                          "type": "input",
                                          "id": "2c55ff74-398b-4be3-9614-f87db217a2d8",
                                          "value": "Отмена",
                                          "placeholder": "Отмена",
                                          "label": "Кнопка"
                                        },
                                        {
                                          "type": "input",
                                          "id": "a5538111-e574-4dfe-904e-a0107d5b4abd",
                                          "value": "Записаться",
                                          "placeholder": "Сохранить",
                                          "label": "Кнопка"
                                        },
                                        {
                                          "type": "p",
                                          "id": "5c7a5b4b-13f4-423c-a8ec-aa5974328e54",
                                          "value": "Укажите ваши данные",
                                          "label": "Параграф / описание",
                                          "placeholder": "Например - Введите пароль"
                                        },
                                        {
                                          "type": "input",
                                          "id": "d4c85c4e-7c0b-4ad7-a5be-bbfa089c275a",
                                          "value": "ФИО",
                                          "placeholder": "Например - Укажите ваше ФИО",
                                          "label": "Текстовый ввод"
                                        },
                                        {
                                          "type": "p",
                                          "id": "dac510a9-fc5c-4806-abb8-e4c095a40fe1",
                                          "value": "Выберите дату и время",
                                          "label": "Параграф / описание",
                                          "placeholder": "Например - Номер телефона"
                                        },
                                        {
                                          "type": "datetime",
                                          "id": "ce9c8b82-424e-4d00-b212-6a9eb539949a",
                                          "value": "",
                                          "label": "Выбор даты/времени",
                                          "placeholder": "Например - Введите пароль"
                                        },
                                        {
                                          "type": "p",
                                          "id": "757a5436-9294-422c-bcc9-cf0219d6ec14",
                                          "value": "Добавьте желаемый дизайн",
                                          "label": "Параграф / описание",
                                          "placeholder": "Например - Введите пароль"
                                        },
                                        {
                                          "type": "file",
                                          "id": "045d524b-b4d3-4d33-b379-8ffd8bfcc034",
                                          "value": "",
                                          "label": "Загрузка файлов",
                                          "placeholder": "Например - Ссылка на сайт"
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        "id": "9161a563-91e4-47b2-8790-6ae447263de7",
                        "number": 0,
                        "type": 8,
                        "title": "Контейнер продукта",
                        "description": "Трехколоночный контейнер: левый текст, центр — банка, правый — описание и характеристики; становится колонкой на мобильных",
                        "tag": "div",
                        "classes": [
                          "product",
                          "product--detail"
                        ],
                        "settings": {
                          "display": "flex",
                          "flexDirection": "row",
                          "justifyContent": "space-between",
                          "alignItems": "flex-start",
                          "flexWrap": "nowrap",
                          "paddingTop": 4,
                          "paddingRight": 3,
                          "paddingBottom": 4,
                          "paddingLeft": 3,
                          "width": "100%",
                          "maxWidth": "1800px",
                          "height": "30rem",
                          "backgroundImage": "url(\"https://sitebypro-server.ru/static/files/f93f24af-cc64-472f-8a26-c5d1b3d78330.png\")",
                          "borderRadius": "1rem",
                          "margin": "0rem 3rem 0rem 0rem",
                          "backgroundSize": "cover",
                          "backgroundPosition": "50% 80%",
                          "backgroundRepeat": "no-repeat",
                          "position": "relative",
                          "responsive": {
                            "480": {
                              "flexDirection": "column",
                              "paddingTop": 1.5,
                              "paddingRight": 1.5,
                              "paddingBottom": 1.5,
                              "paddingLeft": 1.5,
                              "height": "23rem",
                              "margin": "0rem 1rem 0rem 0rem"
                            },
                            "768": {
                              "flexDirection": "column",
                              "paddingTop": 1.5,
                              "paddingRight": 1.5,
                              "paddingBottom": 1.5,
                              "paddingLeft": 1.5,
                              "height": "25rem"
                            },
                            "1245": {
                              "padding": "0rem 0rem 0rem 0rem"
                            }
                          }
                        },
                        "children": {
                          "id": "21d08609-c412-4cdd-bdb9-f643b858199d",
                          "data": [
                            {
                              "id": "b05910ed-5648-4554-9e92-6e143356e931",
                              "number": 1,
                              "title": "Левая колонка — ключевые тексты",
                              "description": "Название, процент алкоголя, ингредиенты",
                              "data": "",
                              "tag": "div",
                              "classes": [
                                "product__left"
                              ],
                              "settings": {
                                "display": "flex",
                                "flexDirection": "column",
                                "justifyContent": "flex-start",
                                "alignItems": "flex-start",
                                "width": "100%",
                                "height": "100%",
                                "responsive": {
                                  "480": {
                                    "width": "100%",
                                    "marginBottom": 2,
                                    "alignItems": "flex-start",
                                    "textAlign": "left"
                                  },
                                  "768": {
                                    "width": "100%",
                                    "marginBottom": 2,
                                    "alignItems": "flex-start",
                                    "textAlign": "left"
                                  },
                                  "1245": {
                                    "padding": "0rem 0rem 0rem 0rem",
                                    "flexWrap": "nowrap"
                                  }
                                }
                              },
                              "children": {
                                "id": "7bd93c12-29c7-4ff4-b033-0a51ce794a5e",
                                "data": [
                                  {
                                    "id": "3a64a194-11e6-4711-b361-fd8d749b686d",
                                    "number": 1,
                                    "title": "Название — NEIPA",
                                    "description": "Крупный декоративный заголовок",
                                    "data": "Дизайн",
                                    "tag": "h1",
                                    "classes": [
                                      "product__title"
                                    ],
                                    "settings": {
                                      "color": "rgb(255, 255, 255)",
                                      "fontSize": 5,
                                      "lineHeight": 1,
                                      "fontWeight": 700,
                                      "textAlign": "left",
                                      "display": "block",
                                      "responsive": {
                                        "480": {
                                          "fontSize": 3,
                                          "textAlign": "center"
                                        },
                                        "768": {
                                          "fontSize": 3.5,
                                          "textAlign": "center"
                                        },
                                        "1245": {
                                          "padding": "0rem 0rem 0rem 0rem",
                                          "flexWrap": "nowrap",
                                          "letterSpacing": 0,
                                          "alignItems": "stretch",
                                          "justifyContent": "flex-start",
                                          "margin": "0rem 0rem 0rem 0rem"
                                        }
                                      },
                                      "font": {
                                        "family": "kucheryavy",
                                        "variants": [
                                          "regular"
                                        ],
                                        "subsets": [
                                          "latin"
                                        ],
                                        "version": "v1",
                                        "files": {
                                          "regular": "https://sitebypro-server.ru/fonts/kucheryavy/Kucheryavy.otf"
                                        },
                                        "category": "sans-serif"
                                      }
                                    }
                                  },
                                  {
                                    "id": "4899a75f-2faf-4207-9b84-2cb228ae31cc",
                                    "number": 2,
                                    "title": "Описание",
                                    "description": "Малый текст с информацией об алкоголе",
                                    "data": "На все случаи жизни",
                                    "tag": "p",
                                    "classes": [
                                      "product__alc"
                                    ],
                                    "settings": {
                                      "color": "#f2f2f2",
                                      "fontSize": 1.5,
                                      "lineHeight": 1.2,
                                      "textAlign": "left",
                                      "responsive": {
                                        "480": {
                                          "textAlign": "left"
                                        },
                                        "768": {
                                          "textAlign": "left"
                                        },
                                        "1245": {
                                          "width": "15",
                                          "marginTop": 0.5
                                        }
                                      }
                                    }
                                  },
                                  {
                                    "id": "c243a838-3ef2-4239-ae99-cb540b02dd00",
                                    "number": 3,
                                    "title": "CTA — Заказать",
                                    "description": "Кнопка заказа/добавления в корзину",
                                    "data": "Записаться",
                                    "tag": "button",
                                    "classes": [
                                      "product__btn",
                                      "btn",
                                      "btn--accent"
                                    ],
                                    "settings": {
                                      "paddingTop": 1,
                                      "paddingRight": 1.5,
                                      "paddingBottom": 1,
                                      "paddingLeft": 1.5,
                                      "borderRadius": 2,
                                      "fontSize": 1.2,
                                      "marginTop": "auto",
                                      "flexDirection": "row",
                                      "backgroundColor": "black",
                                      "color": "#ffffff",
                                      "responsive": {
                                        "480": {
                                          "width": "",
                                          "textAlign": "center",
                                          "justifyContent": "center",
                                          "padding": "0rem 0rem 0rem 0rem",
                                          "flexWrap": "nowrap"
                                        },
                                        "768": {
                                          "width": "",
                                          "padding": "0rem 0rem 0rem 0rem",
                                          "flexWrap": "nowrap",
                                          "justifyContent": "center"
                                        },
                                        "1245": {
                                          "padding": "0rem 0rem 0rem 0rem",
                                          "flexWrap": "nowrap",
                                          "gap": "0.5rem",
                                          "letterSpacing": 0,
                                          "alignItems": "stretch",
                                          "lineHeight": 1,
                                          "justifyContent": "flex-start"
                                        }
                                      }
                                    },
                                    "children": {
                                      "id": "902a7508-9b96-40a9-966c-810705d4059a",
                                      "data": [
                                        {
                                          "id": "8ea119e7-0216-4fdd-a7e1-90f1099b857f",
                                          "number": 1,
                                          "tag": "i",
                                          "title": "Иконка",
                                          "classes": [
                                            "icon",
                                            "far fa-arrow-alt-circle-right"
                                          ],
                                          "data": [],
                                          "settings": {}
                                        }
                                      ]
                                    },
                                    "action": {
                                      "id": "37aa29e9-3680-4a3f-b404-d1c492292585",
                                      "name": "Открыть диаологовое окно",
                                      "slug": "open-modal",
                                      "functionName": "openModal",
                                      "data": [
                                        {
                                          "type": "input",
                                          "id": "050a28f1-af1f-486c-a11b-2ea3e8b659d7",
                                          "value": "Записаться на прием",
                                          "placeholder": "Заголовок",
                                          "label": "Заголовок"
                                        },
                                        {
                                          "type": "input",
                                          "id": "2c55ff74-398b-4be3-9614-f87db217a2d8",
                                          "value": "Отмена",
                                          "placeholder": "Отмена",
                                          "label": "Кнопка"
                                        },
                                        {
                                          "type": "input",
                                          "id": "a5538111-e574-4dfe-904e-a0107d5b4abd",
                                          "value": "Записаться",
                                          "placeholder": "Сохранить",
                                          "label": "Кнопка"
                                        },
                                        {
                                          "type": "p",
                                          "id": "5c7a5b4b-13f4-423c-a8ec-aa5974328e54",
                                          "value": "Укажите ваши данные",
                                          "label": "Параграф / описание",
                                          "placeholder": "Например - Введите пароль"
                                        },
                                        {
                                          "type": "input",
                                          "id": "d4c85c4e-7c0b-4ad7-a5be-bbfa089c275a",
                                          "value": "ФИО",
                                          "placeholder": "Например - Укажите ваше ФИО",
                                          "label": "Текстовый ввод"
                                        },
                                        {
                                          "type": "p",
                                          "id": "dac510a9-fc5c-4806-abb8-e4c095a40fe1",
                                          "value": "Выберите дату и время",
                                          "label": "Параграф / описание",
                                          "placeholder": "Например - Номер телефона"
                                        },
                                        {
                                          "type": "datetime",
                                          "id": "ce9c8b82-424e-4d00-b212-6a9eb539949a",
                                          "value": "",
                                          "label": "Выбор даты/времени",
                                          "placeholder": "Например - Введите пароль"
                                        },
                                        {
                                          "type": "p",
                                          "id": "757a5436-9294-422c-bcc9-cf0219d6ec14",
                                          "value": "Добавьте желаемый дизайн",
                                          "label": "Параграф / описание",
                                          "placeholder": "Например - Введите пароль"
                                        },
                                        {
                                          "type": "file",
                                          "id": "045d524b-b4d3-4d33-b379-8ffd8bfcc034",
                                          "value": "",
                                          "label": "Загрузка файлов",
                                          "placeholder": "Например - Ссылка на сайт"
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    ]
  },
  {
    "name": "hero",
    "title": "Анимационные блоки",
    "id": "hero-001",
    "list": [
      {
        "id": "64b7edd2-5b4d-4aec-8941-117569502d27",
        "name": "hero",
        "title": "Слежение за курсором",
        "component": "uni",
        "preview": "https://sitebypro-server.ru/static/files/blocks/mouse_move.png",
        "data": [
          {
            "id": "0f6f7101-473e-4272-904c-709ae13a9d67",
            "number": 0,
            "type": 8,
            "title": "Контейнер hero",
            "description": "Фон с текстурой, центрированная колонка; адаптивная верстка для разных экранов",
            "data": "",
            "tag": "div",
            "classes": [
              "hero",
              "hero--adaptive"
            ],
            "settings": {
              "display": "flex",
              "flexFlow": "row",
              "justifyContent": "flex-start",
              "alignItems": "center",
              "flexDirection": "column",
              "flexWrap": "nowrap",
              "responsive": {
                "480": {
                  "margin": "0rem 0rem 0rem 0rem",
                  "padding": "5rem 1rem 5rem 1rem"
                },
                "768": {
                  "margin": "0rem 0rem 0rem 0rem",
                  "padding": "5rem 1rem 5rem 1rem"
                },
                "1245": {
                  "margin": "0rem 0rem 0rem 0rem",
                  "padding": "5rem 1rem 5rem 1rem"
                }
              },
              "backgroundColor": "rgb(251, 135, 158)"
            },
            "children": {
              "id": "52e5497f-2626-429c-aad0-2cb0de8042b4",
              "data": [
                {
                  "id": "ca286a61-084e-4ff9-b402-0cfc90f83e45",
                  "number": 1,
                  "title": "Крупный заголовок (многострочный)",
                  "description": "Основной большой текст — адаптивные размеры и переносы",
                  "data": "Красота рождается в деталях",
                  "tag": "h1",
                  "classes": [
                    "hero__title"
                  ],
                  "settings": {
                    "color": "white",
                    "fontSize": "3rem",
                    "lineHeight": "1",
                    "fontWeight": "700",
                    "letterSpacing": "0.02rem",
                    "textAlign": "center",
                    "display": "block",
                    "responsive": {
                      "480": {
                        "fontSize": 3.9,
                        "padding": "0rem 0rem 0rem 0rem",
                        "margin": "0rem 0rem -5rem 0rem",
                        "flexDirection": "row",
                        "justifyContent": "flex-start",
                        "alignItems": "stretch",
                        "flexWrap": "nowrap",
                        "lineHeight": 1,
                        "letterSpacing": 0
                      },
                      "768": {
                        "fontSize": 4.5,
                        "padding": "0rem 0rem 0rem 0rem",
                        "margin": "0rem 0rem -5rem 0rem",
                        "flexDirection": "row",
                        "justifyContent": "flex-start",
                        "alignItems": "stretch",
                        "flexWrap": "nowrap",
                        "lineHeight": 1,
                        "letterSpacing": 0
                      },
                      "1245": {
                        "margin": "0rem 0rem -5rem 0rem",
                        "flexDirection": "row",
                        "justifyContent": "flex-start",
                        "alignItems": "stretch",
                        "flexWrap": "nowrap",
                        "padding": "0rem 0rem 0rem 0rem",
                        "fontSize": 6,
                        "lineHeight": 1,
                        "letterSpacing": 0.1
                      }
                    },
                    "font": {
                      "family": "kucheryavy",
                      "variants": [
                        "regular"
                      ],
                      "subsets": [
                        "cyrillic",
                        "latin"
                      ],
                      "version": "v1",
                      "lastModified": "2025-09-21",
                      "files": {
                        "regular": "https://sitebypro-server.ru/fonts/kucheryavy/Kucheryavy.otf"
                      },
                      "category": "sans-serif",
                      "kind": "webfonts#webfont",
                      "menu": "https://sitebypro-server.ru/fonts/kucheryavy/Kucheryavy.otf",
                      "format": "otf",
                      "url": "https://sitebypro-server.ru/fonts/kucheryavy/Kucheryavy.otf"
                    }
                  }
                },
                {
                  "id": "68178292-48e6-40f3-a75e-7ac2a9d0f7c6",
                  "number": 2,
                  "title": "Изображение банки",
                  "description": "Центральная банка пива, адаптивный размер, частичное перекрытие заголовка",
                  "data": "",
                  "tag": "div",
                  "classes": [
                    "hero__can"
                  ],
                  "settings": {
                    "backgroundImage": "url('https://sitebypro-server.ru/static/files/a9d013bb-24d6-485e-a358-77877387fa0f.png')",
                    "backgroundSize": "contain",
                    "backgroundRepeat": "no-repeat",
                    "backgroundPosition": "center",
                    "width": "20",
                    "height": "20",
                    "responsive": {
                      "480": {},
                      "768": {},
                      "1245": {}
                    },
                    "animation": {
                      "name": "kinesis",
                      "data": [
                        "https://sitebypro-server.ru/static/files/aba8baf3-c514-4e21-a2fd-d2706b889985.png"
                      ]
                    }
                  }
                },
                {
                  "id": "f3af0ca7-b74b-4c9f-adbe-d4968d5ea86e",
                  "number": 4,
                  "title": "Подзаголовок / слоган",
                  "description": "Малый слоган под банкой, адаптивные размеры",
                  "data": "Начни сиять \nс кончиков пальцев",
                  "tag": "p",
                  "classes": [
                    "hero__subtitle"
                  ],
                  "settings": {
                    "color": "white",
                    "fontSize": "1rem",
                    "lineHeight": "1",
                    "fontWeight": "noraml",
                    "textAlign": "center",
                    "zIndex": 1,
                    "responsive": {
                      "480": {
                        "margin": "-5rem 0rem 0rem 0rem",
                        "fontSize": 3,
                        "lineHeight": 1,
                        "letterSpacing": 0,
                        "padding": "0rem 0rem 0rem 0rem"
                      },
                      "768": {
                        "fontSize": 3,
                        "margin": "-8rem 0rem 0rem 0rem",
                        "padding": "0rem 0rem 0rem 0rem",
                        "flexDirection": "row",
                        "justifyContent": "flex-start",
                        "alignItems": "stretch",
                        "flexWrap": "nowrap"
                      },
                      "1245": {
                        "margin": "-8rem 0rem 0rem 0rem",
                        "flexDirection": "row",
                        "justifyContent": "flex-start",
                        "alignItems": "stretch",
                        "flexWrap": "nowrap",
                        "padding": "0rem 0rem 0rem 0rem",
                        "letterSpacing": 0,
                        "lineHeight": 1,
                        "fontSize": 4.5
                      }
                    },
                    "font": {
                      "family": "kucheryavy",
                      "variants": [
                        "regular"
                      ],
                      "subsets": [
                        "cyrillic",
                        "latin"
                      ],
                      "version": "v1",
                      "lastModified": "2025-09-22",
                      "files": {
                        "regular": "https://sitebypro-server.ru/fonts/kucheryavy/Kucheryavy.otf"
                      },
                      "category": "sans-serif",
                      "kind": "webfonts#webfont",
                      "menu": "https://sitebypro-server.ru/fonts/kucheryavy/Kucheryavy.otf",
                      "format": "otf",
                      "url": "https://sitebypro-server.ru/fonts/kucheryavy/Kucheryavy.otf"
                    }
                  }
                }
              ]
            }
          }
        ]
      },
      {
        "id": "bf3b17d9-eef7-47b2-8d72-c837741195a0",
        "name": "product-card",
        "title": "Слайдер + текст",
        "component": "uni",
        "preview": "https://sitebypro-server.ru/static/files/blocks/slider_plus_text.png",
        "data": [
          {
            "id": "52855d73-713d-4a9b-8c0e-e36857a4779e",
            "number": 0,
            "type": 8,
            "title": "Обёртка продукта",
            "description": "Нужна для центрирования блока product--detail",
            "tag": "div",
            "classes": [
              "product-wrapper"
            ],
            "settings": {
              "display": "flex",
              "justifyContent": "center",
              "width": "100%",
              "backgroundColor": "#fb879e",
              "responsive": {
                "480": {},
                "768": {},
                "1245": {
                  "padding": "0rem 0rem 0rem 0rem",
                  "flexWrap": "nowrap"
                }
              }
            },
            "children": {
              "id": "d3b2c1c6-be0f-49a6-9515-0a3b06a69264",
              "data": [
                {
                  "id": "41ade403-c8be-4d43-b061-544f962b18fd",
                  "number": 0,
                  "type": 8,
                  "title": "Контейнер продукта",
                  "description": "Трехколоночный контейнер: левый текст, центр — банка, правый — описание и характеристики; становится колонкой на мобильных",
                  "tag": "div",
                  "classes": [
                    "product",
                    "product--detail"
                  ],
                  "settings": {
                    "display": "flex",
                    "flexDirection": "row",
                    "justifyContent": "space-between",
                    "alignItems": "flex-start",
                    "flexWrap": "nowrap",
                    "paddingTop": 4,
                    "paddingRight": 3,
                    "paddingBottom": 4,
                    "paddingLeft": 3,
                    "width": "100%",
                    "maxWidth": "1300px",
                    "backgroundColor": "#fb879e",
                    "responsive": {
                      "480": {
                        "flexDirection": "column",
                        "paddingTop": 2,
                        "paddingRight": 1,
                        "paddingBottom": 2,
                        "paddingLeft": 1
                      },
                      "768": {
                        "flexDirection": "column",
                        "paddingTop": 3,
                        "paddingRight": 1.5,
                        "paddingBottom": 3,
                        "paddingLeft": 1.5
                      },
                      "1245": {
                        "padding": "0rem 0rem 0rem 0rem"
                      }
                    }
                  },
                  "children": {
                    "id": "6d23dfbd-adcf-4498-bdaf-b13287a74a84",
                    "data": [
                      {
                        "id": "11c4aed8-4fcb-46ab-82db-8c60d082e1a2",
                        "number": 1,
                        "title": "Левая колонка — ключевые тексты",
                        "description": "Название, процент алкоголя, ингредиенты",
                        "data": "",
                        "tag": "div",
                        "classes": [
                          "product__left"
                        ],
                        "settings": {
                          "display": "flex",
                          "flexDirection": "column",
                          "justifyContent": "flex-start",
                          "alignItems": "flex-start",
                          "width": "30%",
                          "height": "100%",
                          "responsive": {
                            "480": {
                              "width": "100%",
                              "marginBottom": 2,
                              "alignItems": "center",
                              "textAlign": "center"
                            },
                            "768": {
                              "width": "100%",
                              "marginBottom": 2,
                              "alignItems": "center",
                              "textAlign": "center"
                            },
                            "1245": {
                              "padding": "0rem 0rem 0rem 0rem",
                              "flexWrap": "nowrap"
                            }
                          }
                        },
                        "children": {
                          "id": "b47c2506-be4c-4fd7-b987-184c8670e7b2",
                          "data": [
                            {
                              "id": "ffe509e2-1de2-4420-b334-1b5b5be8eb7b",
                              "number": 1,
                              "title": "Название — NEIPA",
                              "description": "Крупный декоративный заголовок",
                              "data": "Маникюр",
                              "tag": "h1",
                              "classes": [
                                "product__title"
                              ],
                              "settings": {
                                "color": "#111111",
                                "fontSize": 5,
                                "lineHeight": 1,
                                "fontWeight": 700,
                                "textAlign": "left",
                                "display": "block",
                                "responsive": {
                                  "480": {
                                    "fontSize": 3.2,
                                    "textAlign": "center"
                                  },
                                  "768": {
                                    "fontSize": 4.5,
                                    "textAlign": "center"
                                  },
                                  "1245": {
                                    "padding": "0rem 0rem 0rem 0rem",
                                    "flexWrap": "nowrap",
                                    "letterSpacing": 0,
                                    "alignItems": "stretch"
                                  }
                                },
                                "font": {
                                  "family": "kucheryavy",
                                  "variants": [
                                    "regular"
                                  ],
                                  "subsets": [
                                    "latin"
                                  ],
                                  "version": "v1",
                                  "files": {
                                    "regular": "https://sitebypro-server.ru/fonts/kucheryavy/Kucheryavy.otf"
                                  },
                                  "category": "sans-serif"
                                }
                              }
                            },
                            {
                              "id": "fac2e021-6d74-4cda-b345-d19657c9d16a",
                              "number": 2,
                              "title": "Описание",
                              "description": "Малый текст с информацией об алкоголе",
                              "data": "На все случаи жизни",
                              "tag": "p",
                              "classes": [
                                "product__alc"
                              ],
                              "settings": {
                                "color": "#f2f2f2",
                                "fontSize": 1.5,
                                "lineHeight": 1.2,
                                "marginTop": 0.5,
                                "textAlign": "left",
                                "responsive": {
                                  "480": {
                                    "textAlign": "center"
                                  },
                                  "768": {
                                    "textAlign": "center"
                                  },
                                  "1245": {}
                                }
                              }
                            },
                            {
                              "id": "3c3ce321-4483-4124-80e1-3e63cf17faea",
                              "number": 3,
                              "title": "Ингредиенты",
                              "description": "Список ингредиентов внизу левой колонки",
                              "data": "Педикюр\nДизайн ногтей\nУход за руками и ногтями",
                              "tag": "p",
                              "classes": [
                                "product__ingredients"
                              ],
                              "settings": {
                                "color": "#0b0b0b",
                                "fontSize": 1,
                                "lineHeight": 1.4,
                                "marginTop": 6,
                                "textAlign": "left",
                                "responsive": {
                                  "480": {
                                    "textAlign": "center",
                                    "marginTop": 2,
                                    "fontSize": 1.4
                                  },
                                  "768": {
                                    "textAlign": "center",
                                    "marginTop": 3
                                  },
                                  "1245": {
                                    "marginTop": "auto",
                                    "padding": "0rem 0rem 0rem 0rem",
                                    "flexWrap": "nowrap",
                                    "fontSize": 1.8,
                                    "letterSpacing": 0,
                                    "alignItems": "stretch",
                                    "justifyContent": "flex-start"
                                  }
                                }
                              }
                            }
                          ]
                        }
                      },
                      {
                        "id": "ed7d527d-58d7-4d8e-8a2d-ffe387ae9f8d",
                        "number": 2,
                        "title": "Центральная колонка — изображение банки",
                        "description": "Контейнер для изображения банки с адаптивным размером",
                        "data": "",
                        "tag": "div",
                        "classes": [
                          "product__center"
                        ],
                        "settings": {
                          "display": "flex",
                          "justifyContent": "center",
                          "alignItems": "center",
                          "width": "36%",
                          "height": "100%",
                          "responsive": {
                            "480": {
                              "width": "100%",
                              "marginBottom": 2
                            },
                            "768": {
                              "width": "100%"
                            },
                            "1245": {}
                          }
                        },
                        "children": {
                          "id": "4649e6c8-134a-4c73-8893-d680815969b1",
                          "data": [
                            {
                              "id": "34293bec-6a0f-42af-a531-278a794329c1",
                              "number": 1,
                              "title": "Обертка банки (рамка)",
                              "description": "Внешняя рамка вокруг изображения (визуальная пунктирная рамка оформляется через класс)",
                              "data": "",
                              "tag": "div",
                              "classes": [
                                "product__can-wrap",
                                "dotted-border"
                              ],
                              "settings": {
                                "display": "flex",
                                "justifyContent": "center",
                                "alignItems": "center",
                                "paddingRight": 0,
                                "paddingLeft": 0,
                                "width": "100%",
                                "responsive": {
                                  "480": {
                                    "paddingRight": 1,
                                    "paddingLeft": 1
                                  },
                                  "768": {
                                    "paddingRight": 1.5,
                                    "paddingLeft": 1.5
                                  },
                                  "1245": {}
                                }
                              },
                              "children": {
                                "id": "d24f98a9-97b0-405a-bf23-66c6b01d9561",
                                "data": [
                                  {
                                    "id": "c797904c-796e-40af-9f22-8264bd09bdba",
                                    "number": 1,
                                    "title": "Изображение — банка",
                                    "description": "Фоновое изображение банки с адаптивным размером",
                                    "data": "",
                                    "tag": "div",
                                    "classes": [
                                      "product__can"
                                    ],
                                    "settings": {
                                      "backgroundImage": "url(\"https://sitebypro-server.ru/static/files/19e1e270-6b55-429b-b16f-9b4e5e488744.png\")",
                                      "backgroundSize": "contain",
                                      "backgroundRepeat": "no-repeat",
                                      "backgroundPosition": "center",
                                      "width": 22,
                                      "height": 28,
                                      "responsive": {
                                        "480": {
                                          "width": 14,
                                          "height": 28
                                        },
                                        "768": {
                                          "width": 18,
                                          "height": 36
                                        },
                                        "1245": {}
                                      },
                                      "animation": {
                                        "name": "slider",
                                        "data": [
                                          "https://sitebypro-server.ru/static/files/9bed467b-080d-4d98-9809-863a7e66747b.png",
                                          "https://sitebypro-server.ru/static/files/59a74f66-75fc-430e-a5e8-580023cbfbe5.png",
                                          "https://sitebypro-server.ru/static/files/882a55b5-702a-4fb8-a0d9-8d5b487e4198.png"
                                        ]
                                      }
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        "id": "a2e98640-6fa6-4d0f-b920-d31abaa0f7b3",
                        "number": 3,
                        "title": "Правая колонка — описание и характеристики",
                        "description": "Длинный текст описания, блок характеристик и CTA",
                        "data": "",
                        "tag": "div",
                        "classes": [
                          "product__right"
                        ],
                        "settings": {
                          "display": "flex",
                          "flexDirection": "column",
                          "justifyContent": "flex-start",
                          "alignItems": "flex-start",
                          "width": "30%",
                          "height": "100%",
                          "responsive": {
                            "480": {
                              "width": "100%",
                              "textAlign": "center",
                              "alignItems": "center",
                              "marginTop": 1
                            },
                            "768": {
                              "width": "100%",
                              "textAlign": "center",
                              "alignItems": "center"
                            },
                            "1245": {
                              "padding": "0rem 0rem 0rem 0rem",
                              "flexWrap": "nowrap"
                            }
                          }
                        },
                        "children": {
                          "id": "89acc5c1-1c39-4c9c-a9ab-0bc25afa7f6e",
                          "data": [
                            {
                              "id": "8e4aaac1-58c2-4401-9c40-b1f8ee8c2112",
                              "number": 1,
                              "title": "Описание продукта",
                              "description": "Параграф — детали вкуса и впечатление от NEIPA",
                              "data": "✨ Почувствуйте нежное прикосновение и яркую палитру ощущений. \n💅 Наши мастера соединяют стиль и заботу, чтобы каждая деталь выглядела безупречно. \n🌸 От классики до смелых трендов — ваш маникюр станет отражением настроения и индивидуальности.",
                              "tag": "p",
                              "classes": [
                                "product__description"
                              ],
                              "settings": {
                                "color": "#222222",
                                "fontSize": 1.2,
                                "lineHeight": 1.8,
                                "textAlign": "left",
                                "marginBottom": 2,
                                "responsive": {
                                  "480": {
                                    "textAlign": "center",
                                    "fontSize": 1.4
                                  },
                                  "768": {
                                    "textAlign": "center"
                                  },
                                  "1245": {
                                    "fontSize": 1.2,
                                    "padding": "0rem 0rem 0rem 0rem",
                                    "flexWrap": "nowrap",
                                    "letterSpacing": 0,
                                    "alignItems": "stretch",
                                    "justifyContent": "flex-start",
                                    "flexDirection": "row",
                                    "margin": "0rem 0rem 0rem 0rem",
                                    "width": "auto",
                                    "height": "auto",
                                    "minWidth": "auto",
                                    "minHeight": "auto",
                                    "maxWidth": "auto",
                                    "maxHeight": "auto"
                                  }
                                }
                              }
                            },
                            {
                              "id": "5975f8fb-7556-447d-b01d-e4eee8734465",
                              "number": 2,
                              "title": "Блок характеристик",
                              "description": "Сетка с показателями: температура, цвет, калории, горечь, содержит глютен",
                              "data": "",
                              "tag": "div",
                              "classes": [
                                "product__specs"
                              ],
                              "settings": {
                                "display": "flex",
                                "flexDirection": "column",
                                "justifyContent": "flex-start",
                                "alignItems": "stretch",
                                "width": "100%",
                                "responsive": {
                                  "480": {
                                    "alignItems": "center"
                                  },
                                  "768": {
                                    "alignItems": "center"
                                  },
                                  "1245": {}
                                }
                              },
                              "children": {
                                "id": "cae7df10-7a3f-4a80-add7-843557875584",
                                "data": [
                                  {
                                    "id": "b70d253b-4292-48b2-9cbd-740a21eeb47c",
                                    "number": 1,
                                    "title": "Строка — Температура / Цвет",
                                    "description": "Две колонки: температура и цвет",
                                    "data": "",
                                    "tag": "div",
                                    "classes": [
                                      "product__spec-row"
                                    ],
                                    "settings": {
                                      "display": "flex",
                                      "flexDirection": "row",
                                      "justifyContent": "space-between",
                                      "alignItems": "center",
                                      "marginBottom": 1.5,
                                      "responsive": {
                                        "480": {
                                          "flexDirection": "column",
                                          "gap": "1rem",
                                          "alignItems": "center"
                                        },
                                        "768": {
                                          "flexDirection": "row",
                                          "gap": "1rem",
                                          "alignItems": "center"
                                        },
                                        "1245": {}
                                      }
                                    },
                                    "children": {
                                      "id": "5d6aa6d9-ecb7-4cfc-b762-4675592d52a3",
                                      "data": [
                                        {
                                          "id": "c2edb306-a6d7-43e3-bee2-4704f8aff896",
                                          "number": 1,
                                          "title": "Блочная метка — Температура",
                                          "description": "Температура хранения",
                                          "data": "STANDART\nПрофессионализм",
                                          "tag": "p",
                                          "classes": [
                                            "product__spec"
                                          ],
                                          "settings": {
                                            "fontSize": 1,
                                            "lineHeight": 1.2,
                                            "textAlign": "left",
                                            "responsive": {
                                              "480": {
                                                "textAlign": "center"
                                              },
                                              "768": {},
                                              "1245": {
                                                "fontSize": 1.2
                                              }
                                            }
                                          }
                                        },
                                        {
                                          "id": "777580b3-e7c8-4997-aef5-271863349308",
                                          "number": 2,
                                          "title": "Блочная метка — Цвет",
                                          "description": "Цвет (EBC)",
                                          "data": "Ваш\nДизайн",
                                          "tag": "p",
                                          "classes": [
                                            "product__spec"
                                          ],
                                          "settings": {
                                            "fontSize": 1,
                                            "lineHeight": 1.2,
                                            "textAlign": "right",
                                            "responsive": {
                                              "480": {
                                                "textAlign": "center"
                                              },
                                              "768": {},
                                              "1245": {
                                                "fontSize": 1.2
                                              }
                                            }
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              "id": "36395013-2acf-4cbb-a807-23908ace9c41",
                              "number": 3,
                              "title": "CTA — Заказать",
                              "description": "Кнопка заказа/добавления в корзину",
                              "data": "Записаться",
                              "tag": "button",
                              "classes": [
                                "product__btn",
                                "btn",
                                "btn--accent"
                              ],
                              "settings": {
                                "paddingTop": 1,
                                "paddingRight": 3,
                                "paddingBottom": 1,
                                "paddingLeft": 3,
                                "borderRadius": 2,
                                "fontSize": 1.2,
                                "marginTop": "auto",
                                "responsive": {
                                  "480": {
                                    "width": "",
                                    "textAlign": "center",
                                    "justifyContent": "center",
                                    "padding": "0rem 0rem 0rem 0rem",
                                    "flexWrap": "nowrap"
                                  },
                                  "768": {
                                    "width": "",
                                    "padding": "0rem 0rem 0rem 0rem",
                                    "flexWrap": "nowrap",
                                    "justifyContent": "center"
                                  },
                                  "1245": {
                                    "padding": "0rem 0rem 0rem 0rem",
                                    "flexWrap": "nowrap",
                                    "gap": "0.5rem",
                                    "flexDirection": "row",
                                    "letterSpacing": 0,
                                    "alignItems": "stretch",
                                    "lineHeight": 1,
                                    "justifyContent": "flex-start"
                                  }
                                },
                                "flexDirection": "row"
                              },
                              "children": {
                                "id": "df3d397d-6073-439d-a8b4-ce4f950ca51c",
                                "data": [
                                  {
                                    "id": "7ce56304-e632-4f95-bd63-b2aee2654e35",
                                    "number": 1,
                                    "tag": "i",
                                    "title": "Иконка",
                                    "classes": [
                                      "icon",
                                      "far fa-calendar-alt"
                                    ],
                                    "data": [],
                                    "settings": {}
                                  }
                                ]
                              },
                              "action": {
                                "id": "e81167a9-38ab-46de-b2cc-274afef7eee5",
                                "name": "Открыть диаологовое окно",
                                "slug": "open-modal",
                                "functionName": "openModal",
                                "data": [
                                  {
                                    "type": "input",
                                    "id": "18fbcf7c-44c2-4467-876f-d12f7247474e",
                                    "value": "Записаться на прием",
                                    "placeholder": "Заголовок",
                                    "label": "Заголовок"
                                  },
                                  {
                                    "type": "input",
                                    "id": "d8a12a37-ed7b-4738-b978-582adc03837f",
                                    "value": "Отмена",
                                    "placeholder": "Отмена",
                                    "label": "Кнопка"
                                  },
                                  {
                                    "type": "input",
                                    "id": "b448a481-b0f7-4f44-9a1a-ef43fb7e449d",
                                    "value": "Записаться",
                                    "placeholder": "Сохранить",
                                    "label": "Кнопка"
                                  },
                                  {
                                    "type": "p",
                                    "id": "3bdb0a7f-e707-4312-b007-bca99e7d219c",
                                    "value": "Укажите ваши данные",
                                    "label": "Параграф / описание",
                                    "placeholder": "Например - Введите пароль"
                                  },
                                  {
                                    "type": "input",
                                    "id": "8da381a5-52e0-4360-9121-5d6023280c16",
                                    "value": "ФИО",
                                    "placeholder": "Например - Укажите ваше ФИО",
                                    "label": "Текстовый ввод"
                                  },
                                  {
                                    "type": "p",
                                    "id": "a3c9f651-d6f9-4a28-b0c3-d37a16765115",
                                    "value": "Выберите дату и время",
                                    "label": "Параграф / описание",
                                    "placeholder": "Например - Номер телефона"
                                  },
                                  {
                                    "type": "datetime",
                                    "id": "f42a5f6c-d6c7-4895-8c04-fa1d1686ade8",
                                    "value": "",
                                    "label": "Выбор даты/времени",
                                    "placeholder": "Например - Введите пароль"
                                  },
                                  {
                                    "type": "p",
                                    "id": "e780db53-4399-43a9-b16a-28dd96715d14",
                                    "value": "Добавьте желаемый дизайн",
                                    "label": "Параграф / описание",
                                    "placeholder": "Например - Введите пароль"
                                  },
                                  {
                                    "type": "file",
                                    "id": "5699db0c-2358-4f3e-883d-fd60db00464f",
                                    "value": "",
                                    "label": "Загрузка файлов",
                                    "placeholder": "Например - Ссылка на сайт"
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      },
      {
        "id": "bf3b27d9-eef7-47b2-8d72-c837741195a0",
        "name": "product-card",
        "title": "Слайдшоу галерея",
        "component": "uni",
        "preview": "https://sitebypro-server.ru/static/files/blocks/gallery.png",
        "data": [
          {
            "id": "d842e9a5-3d5e-4251-83b7-72965cc47cf6",
            "number": 0,
            "type": 8,
            "title": "Контейнер продукта",
            "description": "Трехколоночный контейнер: левый текст, центр — банка, правый — описание и характеристики; становится колонкой на мобильных",
            "tag": "div",
            "classes": [
              "product",
              "product--detail"
            ],
            "settings": {
              "display": "flex",
              "flexDirection": "row",
              "justifyContent": "space-between",
              "alignItems": "flex-start",
              "flexWrap": "nowrap",
              "width": "100%",
              "backgroundColor": "rgb(251 135 158)",
              "responsive": {
                "480": {
                  "flexDirection": "column"
                },
                "768": {
                  "flexDirection": "column"
                },
                "1245": {
                  "padding": "0rem 0rem 0rem 0rem"
                }
              }
            },
            "children": {
              "id": "88db3abc-959a-4e84-8e83-f1f4e3f35016",
              "data": [
                {
                  "id": "ce819bd2-855e-45e6-a3f8-19d5c71004ae",
                  "number": 2,
                  "title": "Центральная колонка — изображение банки",
                  "description": "Контейнер для изображения банки с адаптивным размером",
                  "data": "",
                  "tag": "div",
                  "classes": [
                    "product__center"
                  ],
                  "settings": {
                    "display": "flex",
                    "justifyContent": "center",
                    "alignItems": "center",
                    "width": "100%",
                    "height": "100%",
                    "maxWidth": "1800px",
                    "margin": "auto",
                    "responsive": {
                      "480": {},
                      "768": {},
                      "1245": {}
                    }
                  },
                  "children": {
                    "id": "c1d30990-9953-4628-a01f-091e1123eac9",
                    "data": [
                      {
                        "id": "16d2b8e3-6f88-4649-96e4-8d16214cf78a",
                        "number": 1,
                        "title": "Обертка банки (рамка)",
                        "description": "Внешняя рамка вокруг изображения (визуальная пунктирная рамка оформляется через класс)",
                        "data": "",
                        "tag": "div",
                        "classes": [
                          "product__can-wrap",
                          "dotted-border"
                        ],
                        "settings": {
                          "display": "flex",
                          "justifyContent": "center",
                          "alignItems": "center",
                          "paddingRight": 0,
                          "paddingLeft": 0,
                          "width": "100%",
                          "responsive": {
                            "480": {
                              "paddingRight": 1,
                              "paddingLeft": 1
                            },
                            "768": {
                              "paddingRight": 1.5,
                              "paddingLeft": 1.5
                            },
                            "1245": {}
                          }
                        },
                        "children": {
                          "id": "da09518e-378c-4f23-97de-18438fb523fe",
                          "data": [
                            {
                              "id": "6a6fb35a-6479-4195-8835-e4c155999121",
                              "number": 1,
                              "title": "Изображение — банка",
                              "description": "Фоновое изображение банки с адаптивным размером",
                              "data": "",
                              "tag": "div",
                              "classes": [
                                "product__can"
                              ],
                              "settings": {
                                "width": "100%",
                                "height": "100%",
                                "responsive": {
                                  "480": {},
                                  "768": {},
                                  "1245": {}
                                },
                                "animation": {
                                  "name": "infinity",
                                  "data": [
                                    "https://sitebypro-server.ru/static/files/7a7f068e-8761-4eb4-bff6-e14efc1a4874.jpg",
                                    "https://sitebypro-server.ru/static/files/eaaf2de0-1283-4f66-9618-3c4cf335c6cd.jpg",
                                    "https://sitebypro-server.ru/static/files/3f0d3009-ee56-4826-83e9-1b4f877e622d.jpg",
                                    "https://sitebypro-server.ru/static/files/1261ffaa-bf2d-440f-9901-14ad60ae9b96.jpg",
                                    "https://sitebypro-server.ru/static/files/8aec125c-28a9-4d28-b09c-1ea0c0265d28.jpg",
                                    "https://sitebypro-server.ru/static/files/b69be05c-81a0-43de-b3a6-723aae300990.jpg",
                                    "https://sitebypro-server.ru/static/files/15ab3b26-b9bd-4091-92ff-2c77fad35167.jpg",
                                    "https://sitebypro-server.ru/static/files/da48b8ad-38a3-411d-b537-109d7bebc283.jpg"
                                  ]
                                }
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    ]
  },
  {
    "name": "product",
    "title": "Функциональные блоки",
    "id": "product-001",
    "list": [
      {
        "id": "bf3b27d9-eef7-47b2-8d72-c837741195a0",
        "name": "product-card",
        "title": "Выпадающий список",
        "component": "uni",
        "preview": "https://sitebypro-server.ru/static/files/blocks/list.png",
        "data": [
          {
            "id": "d84fe9a5-3d5e-4251-83b7-72965cc47cf6",
            "number": 0,
            "type": 8,
            "title": "Контейнер продукта",
            "description": "Трехколоночный контейнер: левый текст, центр — банка, правый — описание и характеристики; становится колонкой на мобильных",
            "tag": "div",
            "classes": [
              "product",
              "product--detail"
            ],
            "settings": {
              "display": "flex",
              "flexDirection": "row",
              "justifyContent": "space-between",
              "alignItems": "flex-start",
              "flexWrap": "nowrap",
              "width": "100%",
              "backgroundColor": "rgb(251 135 158)",
              "responsive": {
                "480": {
                  "flexDirection": "column"
                },
                "768": {
                  "flexDirection": "column"
                },
                "1245": {
                  "padding": "0rem 0rem 0rem 0rem"
                }
              }
            },
            "children": {
              "id": "88db3abc-959a-4e84-8e83-f1f4e3f35016",
              "data": [
                {
                  "id": "ce819bd2-855e-45e6-a3f8-19d5c71004ae",
                  "number": 2,
                  "title": "Центральная колонка — изображение банки",
                  "description": "Контейнер для изображения банки с адаптивным размером",
                  "data": "",
                  "tag": "div",
                  "classes": [
                    "product__center"
                  ],
                  "settings": {
                    "display": "flex",
                    "justifyContent": "center",
                    "alignItems": "center",
                    "width": "100%",
                    "height": "100%",
                    "maxWidth": "1800px",
                    "margin": "auto",
                    "responsive": {
                      "480": {},
                      "768": {},
                      "1245": {}
                    }
                  },
                  "children": {
                    "id": "c1d30990-9953-4628-a01f-091e1123eac9",
                    "data": [
                      {
                        "id": "16d2b8e3-6f88-4649-96e4-8d16214cf78a",
                        "number": 1,
                        "title": "Обертка банки (рамка)",
                        "description": "Внешняя рамка вокруг изображения (визуальная пунктирная рамка оформляется через класс)",
                        "data": "",
                        "tag": "div",
                        "classes": [
                          "product__can-wrap",
                          "dotted-border"
                        ],
                        "settings": {
                          "display": "flex",
                          "justifyContent": "center",
                          "alignItems": "center",
                          "paddingRight": 0,
                          "paddingLeft": 0,
                          "width": "100%",
                          "responsive": {
                            "480": {
                              "margin": "1.5rem"
                            },
                            "768": {
                              "margin": "1.5rem"
                            },
                            "1245": {
                              "margin": "3rem"
                            }
                          }
                        },
                        "children": {
                          "id": "da09518e-378c-4f23-97de-18438fb523fe",
                          "data": [
                            {
                              "id": "6a6fb35a-6479-4195-8835-e4c155999121",
                              "number": 1,
                              "title": "Изображение — банка",
                              "description": "Фоновое изображение банки с адаптивным размером",
                              "data": "",
                              "tag": "div",
                              "classes": [
                                "product__can"
                              ],
                              "settings": {
                                "width": "100%",
                                "height": "100%",
                                "responsive": {
                                  "480": {
                                    "height": "100%"
                                  },
                                  "768": {
                                    "height": "100%"
                                  },
                                  "1245": {
                                    "height": "100%"
                                  }
                                },
                                "animation": {
                                  "name": "list",
                                  "data": [
                                    {
                                      "id": "parent-services-001",
                                      "name": "Маникюр",
                                      "icon": "fas fa-hand-paper",
                                      "children": [
                                        {
                                          "id": "svc-0001-manicure",
                                          "name": "Маникюр (классический, аппаратный, европейский)",
                                          "icon": "far fa-hand-paper",
                                          "attributes": [
                                            {
                                              "key": "price_master",
                                              "value": 850
                                            },
                                            {
                                              "key": "currency",
                                              "value": "RUB"
                                            }
                                          ]
                                        },
                                        {
                                          "id": "svc-0002-child-manicure",
                                          "name": "Детский маникюр",
                                          "icon": "fas fa-baby",
                                          "attributes": [
                                            {
                                              "key": "price_master",
                                              "value": 400
                                            },
                                            {
                                              "key": "currency",
                                              "value": "RUB"
                                            }
                                          ]
                                        },
                                        {
                                          "id": "svc-0003-japanese-manicure",
                                          "name": "Маникюр японский",
                                          "icon": "fas fa-star-of-life",
                                          "attributes": [
                                            {
                                              "key": "price_master",
                                              "value": 1500
                                            },
                                            {
                                              "key": "currency",
                                              "value": "RUB"
                                            }
                                          ]
                                        },
                                        {
                                          "id": "svc-0004-nail-polish-bio-wax",
                                          "name": "Полировка ногтей с биовоском лечебным",
                                          "icon": "far fa-gem",
                                          "attributes": [
                                            {
                                              "key": "price_master",
                                              "value": 250
                                            },
                                            {
                                              "key": "currency",
                                              "value": "RUB"
                                            }
                                          ]
                                        },
                                        {
                                          "id": "svc-0005-paraffin-therapy",
                                          "name": "Парафинотерапия рук",
                                          "icon": "fas fa-hands",
                                          "attributes": [
                                            {
                                              "key": "price_master",
                                              "value": 350
                                            },
                                            {
                                              "key": "currency",
                                              "value": "RUB"
                                            }
                                          ]
                                        },
                                        {
                                          "id": "svc-0006-spa-nogturne",
                                          "name": "Spa-уход для рук nogturne",
                                          "icon": "fas fa-spa",
                                          "attributes": [
                                            {
                                              "key": "price_master",
                                              "value": 450
                                            },
                                            {
                                              "key": "currency",
                                              "value": "RUB"
                                            }
                                          ]
                                        },
                                        {
                                          "id": "svc-0007-hand-massage-15min",
                                          "name": "Массаж кистей 15 минут",
                                          "icon": "far fa-hand-rock",
                                          "attributes": [
                                            {
                                              "key": "price_master",
                                              "value": 400
                                            },
                                            {
                                              "key": "currency",
                                              "value": "RUB"
                                            }
                                          ]
                                        },
                                        {
                                          "id": "svc-0008-correct-claw-nail",
                                          "name": "Исправление клюющего ногтя",
                                          "icon": "fas fa-tools",
                                          "attributes": [
                                            {
                                              "key": "price_master",
                                              "value": 250
                                            },
                                            {
                                              "key": "currency",
                                              "value": "RUB"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    {
                                      "id": "parent-services-002",
                                      "name": "Педикюр",
                                      "icon": "fas fa-shoe-prints",
                                      "children": [
                                        {
                                          "id": "svc-0101-toes-treatment",
                                          "name": "Обработка пальчиков",
                                          "icon": "fas fa-shoe-prints",
                                          "attributes": [
                                            {
                                              "key": "price_master",
                                              "value": 850
                                            },
                                            {
                                              "key": "currency",
                                              "value": "RUB"
                                            }
                                          ]
                                        },
                                        {
                                          "id": "svc-0102-feet-treatment",
                                          "name": "Обработка стоп",
                                          "icon": "fas fa-bong",
                                          "attributes": [
                                            {
                                              "key": "price_master",
                                              "value": 850
                                            },
                                            {
                                              "key": "currency",
                                              "value": "RUB"
                                            }
                                          ]
                                        },
                                        {
                                          "id": "svc-0103-classic-pedicure",
                                          "name": "Педикюр (классический, аппаратный)",
                                          "icon": "fas fa-cut",
                                          "attributes": [
                                            {
                                              "key": "price_master",
                                              "value": 1700
                                            },
                                            {
                                              "key": "currency",
                                              "value": "RUB"
                                            }
                                          ]
                                        },
                                        {
                                          "id": "svc-0104-smart-pedicure",
                                          "name": "Смарт-педикюр",
                                          "icon": "fas fa-microchip",
                                          "attributes": [
                                            {
                                              "key": "price_master",
                                              "value": 2250
                                            },
                                            {
                                              "key": "currency",
                                              "value": "RUB"
                                            }
                                          ]
                                        },
                                        {
                                          "id": "svc-0105-golden-trace-pedicure",
                                          "name": "Педикюр golden trace",
                                          "icon": "fas fa-gem",
                                          "attributes": [
                                            {
                                              "key": "price_master",
                                              "value": 2400
                                            },
                                            {
                                              "key": "currency",
                                              "value": "RUB"
                                            }
                                          ]
                                        },
                                        {
                                          "id": "svc-0106-fruit-acid-pedicure",
                                          "name": "Фруктово-кислотный педикюр",
                                          "icon": "fas fa-lemon",
                                          "attributes": [
                                            {
                                              "key": "price_master",
                                              "value": 2400
                                            },
                                            {
                                              "key": "currency",
                                              "value": "RUB"
                                            }
                                          ]
                                        },
                                        {
                                          "id": "svc-0107-paraffin-feet",
                                          "name": "Парафинотерапия ног",
                                          "icon": "fas fa-hot-tub",
                                          "attributes": [
                                            {
                                              "key": "price_master",
                                              "value": 450
                                            },
                                            {
                                              "key": "currency",
                                              "value": "RUB"
                                            }
                                          ]
                                        },
                                        {
                                          "id": "svc-0108-feet-massage-15min",
                                          "name": "Массаж стоп 15 минут",
                                          "icon": "fas fa-shoe-prints",
                                          "attributes": [
                                            {
                                              "key": "price_master",
                                              "value": 400
                                            },
                                            {
                                              "key": "currency",
                                              "value": "RUB"
                                            }
                                          ]
                                        },
                                        {
                                          "id": "svc-0109-nail-prosthetics",
                                          "name": "Протезирование ногтя",
                                          "icon": "fas fa-band-aid",
                                          "attributes": [
                                            {
                                              "key": "price_master",
                                              "value": 1000
                                            },
                                            {
                                              "key": "currency",
                                              "value": "RUB"
                                            }
                                          ]
                                        },
                                        {
                                          "id": "svc-0110-tamponade",
                                          "name": "Тампонада",
                                          "icon": "fas fa-clinic-medical",
                                          "attributes": [
                                            {
                                              "key": "price_master",
                                              "value": 150
                                            },
                                            {
                                              "key": "currency",
                                              "value": "RUB"
                                            }
                                          ]
                                        },
                                        {
                                          "id": "svc-0111-titan-wire-install",
                                          "name": "Установка титановой нити",
                                          "icon": "fas fa-project-diagram",
                                          "attributes": [
                                            {
                                              "key": "price_master",
                                              "value": 3750
                                            },
                                            {
                                              "key": "currency",
                                              "value": "RUB"
                                            }
                                          ]
                                        },
                                        {
                                          "id": "svc-0112-titan-wire-reinstall",
                                          "name": "Переустановка титановой нити",
                                          "icon": "fas fa-redo",
                                          "attributes": [
                                            {
                                              "key": "price_master",
                                              "value": 2050
                                            },
                                            {
                                              "key": "currency",
                                              "value": "RUB"
                                            }
                                          ]
                                        },
                                        {
                                          "id": "svc-0113-tape-one",
                                          "name": "Тейп 1 шт",
                                          "icon": "fas fa-tape",
                                          "attributes": [
                                            {
                                              "key": "price_master",
                                              "value": 300
                                            },
                                            {
                                              "key": "currency",
                                              "value": "RUB"
                                            }
                                          ]
                                        },
                                        {
                                          "id": "svc-0114-corn-treatment",
                                          "name": "Обработка стержневой мозоли",
                                          "icon": "fas fa-bullseye",
                                          "attributes": [
                                            {
                                              "key": "price_master",
                                              "value": 250
                                            },
                                            {
                                              "key": "currency",
                                              "value": "RUB"
                                            }
                                          ]
                                        },
                                        {
                                          "id": "svc-0115-relief-corns-cracks",
                                          "name": "Разгрузка при мозолях/трещинах 1 шт",
                                          "icon": "fas fa-compress-arrows-alt",
                                          "attributes": [
                                            {
                                              "key": "price_master",
                                              "value": 400
                                            },
                                            {
                                              "key": "currency",
                                              "value": "RUB"
                                            }
                                          ]
                                        }
                                      ]
                                    }
                                  ]
                                }
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    ]
  },
  {
    "name": "navbar",
    "title": "Подвал",
    "id": "nav-001",
    "list": [
      {
        "id": "7eda976e-b242-4750-9db1-c301cd737e42",
        "name": "navbar",
        "title": "Классический",
        "component": "uni",
        "preview": "https://sitebypro-server.ru/static/files/blocks/footer.png",
        "data": [
          {
            "id": "3xb265e0-43be-4841-8ddd-aacdbd93dcb3",
            "number": 0,
            "type": 9,
            "title": "Внешний контейнер для nav--main",
            "description": "Обёртка, центрирует и ограничивает ширину навигации",
            "data": "",
            "tag": "div",
            "classes": [
              "nav--outer"
            ],
            "settings": {
              "display": "flex",
              "justifyContent": "center",
              "alignItems": "center",
              "width": "100%",
              "padding": "0 1rem",
              "backgroundColor": "rgb(0, 0, 0)",
              "responsive": {
                "480": {
                  "padding": "0 1rem"
                },
                "768": {
                  "padding": "0 1rem"
                },
                "1245": {}
              }
            },
            "children": {
              "id": "ecf39df7-a2eb-sf07-a0c7-8a639ce5086b",
              "data": [
                {
                  "id": "w9309a1d-0fd5-4acb-9b18-aea3715c277e",
                  "number": 0,
                  "type": 8,
                  "title": "Контейнер nav",
                  "description": "Главный контейнер навигационного бара",
                  "data": "",
                  "tag": "div",
                  "classes": [
                    "nav",
                    "nav--main"
                  ],
                  "settings": {
                    "width": "100%",
                    "maxWidth": "1300px",
                    "margin": "auto",
                    "padding": "3rem",
                    "display": "flex",
                    "flexDirection": "row",
                    "flexWrap": "nowrap",
                    "justifyContent": "space-between",
                    "alignItems": "flex-start",
                    "backgroundColor": "rgb(0, 0, 0)",
                    "responsive": {
                      "480": {
                        "padding": "3rem 1rem",
                        "display": "flex",
                        "flexFlow": "row",
                        "justifyContent": "space-between",
                        "alignItems": "flex-start",
                        "flexDirection": "column",
                        "textAlign": "left",
                        "flexWrap": "nowrap",
                        "backgroundColor": "transparent"
                      },
                      "768": {
                        "padding": "3rem 1rem",
                        "display": "flex",
                        "flexFlow": "row",
                        "justifyContent": "space-between",
                        "alignItems": "flex-start",
                        "flexDirection": "column",
                        "textAlign": "left",
                        "flexWrap": "nowrap",
                        "backgroundColor": "transparent"
                      },
                      "1245": {}
                    }
                  },
                  "children": {
                    "id": "4205ff4r-v980-492b-ab58-022a08c220cf",
                    "data": [
                      {
                        "id": "7es873fa-199f-48c4-9ba9-6c8ac1018de1",
                        "number": 1,
                        "title": "Логотип",
                        "description": "Лого Студия маникюра",
                        "data": "",
                        "tag": "div",
                        "classes": [
                          "nav__logo"
                        ],
                        "settings": {
                          "width": "4rem",
                          "height": "4rem",
                          "marginRight": "0rem",
                          "backgroundImage": "url(\"https://sitebypro-server.ru/static/files/4147ebd5-248d-4c73-aa6b-b6e852c331ae.svg\")",
                          "backgroundSize": "contain",
                          "backgroundRepeat": "no-repeat",
                          "backgroundPosition": "center",
                          "responsive": {
                            "480": {
                              "width": "4rem",
                              "height": "4rem"
                            },
                            "768": {
                              "width": "4rem",
                              "height": "4rem"
                            },
                            "1245": {}
                          }
                        }
                      },
                      {
                        "id": "400cf763-e7f1-486f-97a4-25a2eg011305",
                        "number": 2,
                        "title": "Меню навигации",
                        "description": "Семантический список навигации с пунктами: Услуги, Галерея, Цены, О нас",
                        "data": "",
                        "tag": "div",
                        "classes": [
                          "nav__list"
                        ],
                        "settings": {
                          "display": "flex",
                          "flexDirection": "column",
                          "flexWrap": "nowrap",
                          "justifyContent": "flex-start",
                          "alignItems": "flex-start",
                          "gap": "0.5rem",
                          "responsive": {
                            "480": {
                              "display": "flex",
                              "flexFlow": "row",
                              "justifyContent": "flex-start",
                              "alignItems": "flex-start",
                              "gap": "0.5rem",
                              "marginTop": "1rem",
                              "flexDirection": "column",
                              "textAlign": "left"
                            },
                            "768": {
                              "display": "flex",
                              "flexDirection": "column",
                              "flexWrap": "nowrap",
                              "justifyContent": "flex-start",
                              "alignItems": "flex-start",
                              "gap": "0.5rem",
                              "marginTop": "1rem",
                              "textAlign": "left"
                            },
                            "1248": {}
                          }
                        },
                        "children": {
                          "id": "533v4v55-7749-4457-b7cf-579d9b9fcef3",
                          "data": [
                            {
                              "id": "57d3g907-0cab-44fb-883a-4885ec3fe78b",
                              "number": 1,
                              "title": "Пункт меню — Услуги",
                              "description": "Ссылка на раздел услуг",
                              "data": "",
                              "tag": "p",
                              "classes": [
                                "nav__item"
                              ],
                              "children": {
                                "id": "fbw74c64-6171-4b65-9964-7119a7c15d2f",
                                "data": [
                                  {
                                    "id": "0e28b8ad-6a3b-43f7-8d53-5ba48259a621",
                                    "number": 0,
                                    "title": "Ссылка — Услуги",
                                    "description": "Текст ссылки",
                                    "data": "Навигация",
                                    "tag": "p",
                                    "classes": [
                                      "nav__link"
                                    ],
                                    "settings": {
                                      "fontWeight": "bold",
                                      "responsive": {
                                        "480": {
                                          "fontSize": "1.5rem"
                                        },
                                        "768": {
                                          "fontSize": "1.5rem"
                                        },
                                        "1245": {}
                                      }
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              "id": "57d3q907-0cab-44fb-883a-4885ec3fe78b",
                              "number": 1,
                              "title": "Пункт меню — Услуги",
                              "description": "Ссылка на раздел услуг",
                              "data": "",
                              "tag": "p",
                              "classes": [
                                "nav__item"
                              ],
                              "children": {
                                "id": "fbs74c64-6171-4b65-9964-7119a7c15d2f",
                                "data": [
                                  {
                                    "id": "0e2888ad-6a3b-43f7-8d53-5ba48259a621",
                                    "number": 0,
                                    "title": "Ссылка — Услуги",
                                    "description": "Текст ссылки",
                                    "data": "Услуги",
                                    "tag": "p",
                                    "classes": [
                                      "nav__link"
                                    ],
                                    "settings": {
                                      "cursor": "pointer",
                                      "responsive": {
                                        "480": {
                                          "fontSize": "1.5rem"
                                        },
                                        "768": {
                                          "fontSize": "1.5rem"
                                        },
                                        "1245": {}
                                      }
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              "id": "ft601c9f-afb8-496b-9e26-380e252069ed",
                              "number": 2,
                              "title": "Пункт меню — Галерея",
                              "description": "Ссылка на галерею работ",
                              "data": "",
                              "tag": "p",
                              "classes": [
                                "nav__item"
                              ],
                              "children": {
                                "id": "5b20g85b-9c51-4a08-9c34-7e40220e94a1",
                                "data": [
                                  {
                                    "id": "fb8aga18-607c-4f9c-a146-677d7f16a4ea",
                                    "number": 0,
                                    "title": "Ссылка — Галерея",
                                    "description": "Текст ссылки",
                                    "data": "Галерея",
                                    "tag": "p",
                                    "classes": [
                                      "nav__link"
                                    ],
                                    "settings": {
                                      "cursor": "pointer",
                                      "responsive": {
                                        "480": {
                                          "fontSize": "1.5rem"
                                        },
                                        "768": {
                                          "fontSize": "1.5rem"
                                        },
                                        "1245": {}
                                      }
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              "id": "28233e02-55f6-45d4-8243-27e2a6003dd6",
                              "number": 3,
                              "title": "Пункт меню — Цены",
                              "description": "Ссылка на страницу цен",
                              "data": "",
                              "tag": "p",
                              "classes": [
                                "nav__item"
                              ],
                              "children": {
                                "id": "d67a1758-74f0-4404-8e25-b0gb5dd8b1ac",
                                "data": [
                                  {
                                    "id": "0bd6vfec-9ada-4422-8686-d48ffa859c45",
                                    "number": 0,
                                    "title": "Ссылка — Цены",
                                    "description": "Текст ссылки",
                                    "data": "Цены",
                                    "tag": "p",
                                    "classes": [
                                      "nav__link"
                                    ],
                                    "settings": {
                                      "cursor": "pointer",
                                      "responsive": {
                                        "480": {
                                          "fontSize": "1.5rem"
                                        },
                                        "768": {
                                          "fontSize": "1.5rem"
                                        },
                                        "1245": {}
                                      }
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              "id": "d067gf60-124d-47c2-88e5-7276012d050b",
                              "number": 4,
                              "title": "Пункт меню — О нас",
                              "description": "Ссылка на страницу о салоне",
                              "data": "",
                              "tag": "p",
                              "classes": [
                                "nav__item"
                              ],
                              "children": {
                                "id": "cf8aa1fe-2ab0-483f-a71b-081cce8f647e",
                                "data": [
                                  {
                                    "id": "920f6733-3694-4c73-b9f5-ae7727951d8b",
                                    "number": 0,
                                    "title": "Ссылка — О нас",
                                    "description": "Текст ссылки",
                                    "data": "О нас",
                                    "tag": "p",
                                    "classes": [
                                      "nav__link"
                                    ],
                                    "settings": {
                                      "cursor": "pointer",
                                      "responsive": {
                                        "480": {
                                          "fontSize": "1.5rem"
                                        },
                                        "768": {
                                          "fontSize": "1.5rem"
                                        },
                                        "1245": {}
                                      }
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        "id": "400c47f3-e7f1-486f-97a4-25a2ee011305",
                        "number": 2,
                        "title": "Меню навигации",
                        "description": "Семантический список навигации с пунктами: Услуги, Галерея, Цены, О нас",
                        "data": "",
                        "tag": "div",
                        "classes": [
                          "nav__list"
                        ],
                        "settings": {
                          "display": "flex",
                          "flexDirection": "column",
                          "flexWrap": "nowrap",
                          "justifyContent": "flex-start",
                          "alignItems": "flex-start",
                          "gap": "0.5rem",
                          "responsive": {
                            "480": {
                              "display": "flex",
                              "flexFlow": "row",
                              "justifyContent": "flex-start",
                              "alignItems": "flex-start",
                              "gap": "0.5rem",
                              "marginTop": "1rem",
                              "flexDirection": "column",
                              "textAlign": "left"
                            },
                            "768": {
                              "display": "flex",
                              "flexDirection": "column",
                              "flexWrap": "nowrap",
                              "justifyContent": "flex-start",
                              "alignItems": "flex-start",
                              "gap": "0.5rem",
                              "marginTop": "1rem",
                              "textAlign": "left"
                            },
                            "1248": {}
                          }
                        },
                        "children": {
                          "id": "533v4d55-7749-4457-b7cf-579d9b9fcef3",
                          "data": [
                            {
                              "id": "57d3v907-0cab-44fb-883a-4885ec3fe78b",
                              "number": 1,
                              "title": "Пункт меню — Услуги",
                              "description": "Ссылка на раздел услуг",
                              "data": "",
                              "tag": "p",
                              "classes": [
                                "nav__item"
                              ],
                              "children": {
                                "id": "fbs7gc64-6171-4b65-9964-7119a7c15d2f",
                                "data": [
                                  {
                                    "id": "0e2w88ad-6a3b-43f7-8d53-5ba48259a621",
                                    "number": 0,
                                    "title": "Ссылка — ",
                                    "description": "Текст ссылки",
                                    "data": "Адрес:",
                                    "tag": "p",
                                    "classes": [
                                      "nav__link"
                                    ],
                                    "settings": {
                                      "fontWeight": "bold",
                                      "responsive": {
                                        "480": {
                                          "fontSize": "1.5rem"
                                        },
                                        "768": {
                                          "fontSize": "1.5rem"
                                        },
                                        "1245": {}
                                      }
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              "id": "ft601c9f-afb8-496b-9e26-38we252069ed",
                              "number": 2,
                              "title": "Пункт меню — Галерея",
                              "description": "Ссылка на галерею работ",
                              "data": "",
                              "tag": "p",
                              "classes": [
                                "nav__item"
                              ],
                              "children": {
                                "id": "5b20g85b-9c51-4e08-9c34-7e40220e94a1",
                                "data": [
                                  {
                                    "id": "fb8aga18-6r7c-4f9c-a146-677d7f16a4ea",
                                    "number": 0,
                                    "title": "Ссылка — Текст",
                                    "description": "Текст ссылки",
                                    "data": "г. Санкт-Петербург, ул. Набережная приволжского затона, д. 4, пом. 12",
                                    "tag": "p",
                                    "classes": [
                                      "nav__link"
                                    ],
                                    "settings": {
                                      "cursor": "pointer",
                                      "textAlign": "left",
                                      "responsive": {
                                        "480": {
                                          "fontSize": "1.5rem"
                                        },
                                        "768": {
                                          "fontSize": "1.5rem"
                                        },
                                        "1245": {
                                          "maxWidth": "15rem"
                                        }
                                      }
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              "id": "2823fe02-55f6-45d4-8243-27e2a6003dd6",
                              "number": 3,
                              "title": "Пункт меню — Email",
                              "description": "Ссылка на страницу цен",
                              "data": "",
                              "tag": "p",
                              "classes": [
                                "nav__item"
                              ],
                              "children": {
                                "id": "d67ag758-74f0-4404-8e25-b0gb5dd8b1ac",
                                "data": [
                                  {
                                    "id": "0bd6vfec-9ada-4422-8686-d48ffag59c45",
                                    "number": 0,
                                    "title": "Ссылка — Email",
                                    "description": "Текст ссылки",
                                    "data": "Email:",
                                    "tag": "p",
                                    "classes": [
                                      "nav__link"
                                    ],
                                    "settings": {
                                      "fontWeight": "bold",
                                      "responsive": {
                                        "480": {
                                          "fontSize": "1.5rem"
                                        },
                                        "768": {
                                          "fontSize": "1.5rem"
                                        },
                                        "1245": {}
                                      }
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              "id": "d067tf60-124d-47c2-88e5-7w76012d050b",
                              "number": 4,
                              "title": "Пункт меню — О нас",
                              "description": "Ссылка на страницу о салоне",
                              "data": "",
                              "tag": "p",
                              "classes": [
                                "nav__item"
                              ],
                              "children": {
                                "id": "cfaaa1fe-2ab0-483f-a71b-081cce8f647e",
                                "data": [
                                  {
                                    "id": "9x0f6733-3694-4c73-b9f5-ae7727951d8b",
                                    "number": 0,
                                    "title": "Ссылка — О нас",
                                    "description": "Текст ссылки",
                                    "data": "nudenails@mail.ru",
                                    "tag": "p",
                                    "classes": [
                                      "nav__link"
                                    ],
                                    "settings": {
                                      "cursor": "pointer",
                                      "responsive": {
                                        "480": {
                                          "fontSize": "1.5rem"
                                        },
                                        "768": {
                                          "fontSize": "1.5rem"
                                        },
                                        "1245": {}
                                      }
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        "id": "66101f35-12c5-48c0-bf0d-fba2e46dacaf",
                        "number": 2,
                        "title": "Меню навигации",
                        "description": "Семантический список навигации с пунктами: Услуги, Галерея, Цены, О нас",
                        "data": "",
                        "tag": "div",
                        "classes": [
                          "nav__list"
                        ],
                        "settings": {
                          "display": "flex",
                          "flexDirection": "column",
                          "flexWrap": "nowrap",
                          "justifyContent": "flex-start",
                          "alignItems": "flex-start",
                          "gap": "0.5rem",
                          "responsive": {
                            "480": {
                              "display": "flex",
                              "flexFlow": "row",
                              "justifyContent": "flex-start",
                              "alignItems": "flex-start",
                              "gap": "0.5rem",
                              "marginTop": "1rem",
                              "flexDirection": "column",
                              "textAlign": "left"
                            },
                            "768": {
                              "display": "flex",
                              "flexDirection": "column",
                              "flexWrap": "nowrap",
                              "justifyContent": "flex-start",
                              "alignItems": "flex-start",
                              "gap": "0.5rem",
                              "marginTop": "1rem",
                              "textAlign": "left"
                            },
                            "1248": {}
                          }
                        },
                        "children": {
                          "id": "19d54152-7c30-4080-b46a-d989384fa6fc",
                          "data": [
                            {
                              "id": "5669bb7f-393c-4b2a-98f5-ca1e180e7e5b",
                              "number": 1,
                              "title": "Пункт меню — Услуги",
                              "description": "Ссылка на раздел услуг",
                              "data": "",
                              "tag": "p",
                              "classes": [
                                "nav__item"
                              ],
                              "children": {
                                "id": "095de111-06da-4b9a-901c-e65b54081a3e",
                                "data": [
                                  {
                                    "id": "c30a4618-1345-48e5-9e0d-25e5541a3f57",
                                    "number": 0,
                                    "title": "Ссылка — Услуги",
                                    "description": "Текст ссылки",
                                    "data": "Соцсети",
                                    "tag": "p",
                                    "classes": [
                                      "nav__link"
                                    ],
                                    "settings": {
                                      "fontWeight": "bold",
                                      "responsive": {
                                        "480": {
                                          "fontSize": "1.5rem"
                                        },
                                        "768": {
                                          "fontSize": "1.5rem"
                                        },
                                        "1245": {}
                                      }
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              "id": "75c9fa57-4bb4-46c8-86c3-8069a4ff7b18",
                              "number": 2,
                              "title": "Пункт меню — Галерея",
                              "description": "Ссылка на галерею работ",
                              "data": "",
                              "tag": "p",
                              "classes": [
                                "nav__item"
                              ],
                              "children": {
                                "id": "539090ed-e9af-4005-a8b8-b094d81f49af",
                                "data": [
                                  {
                                    "id": "b4e6a0f5-fae1-4222-9e55-dbeb83553f17",
                                    "number": 0,
                                    "title": "Ссылка — Галерея",
                                    "description": "Текст ссылки",
                                    "data": "Инста",
                                    "tag": "p",
                                    "classes": [
                                      "nav__link"
                                    ],
                                    "settings": {
                                      "padding": "0rem 0rem 0rem 0rem",
                                      "flexWrap": "nowrap",
                                      "justifyContent": "center",
                                      "alignItems": "center",
                                      "gap": "0.5rem",
                                      "cursor": "pointer",
                                      "responsive": {
                                        "480": {
                                          "fontSize": "1.5rem"
                                        },
                                        "768": {
                                          "fontSize": "1.5rem"
                                        },
                                        "1245": {}
                                      }
                                    },
                                    "children": {
                                      "id": "id-k09y8ici0",
                                      "data": [
                                        {
                                          "id": "id-eqb4mp9n7",
                                          "number": 0,
                                          "tag": "i",
                                          "title": "Иконка",
                                          "classes": [
                                            "icon",
                                            "fab fa-instagram"
                                          ],
                                          "data": [],
                                          "settings": {}
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              "id": "6484b300-5ffd-47d6-8ec5-5e826f459e4f",
                              "number": 3,
                              "title": "Пункт меню — Цены",
                              "description": "Ссылка на страницу цен",
                              "data": "",
                              "tag": "p",
                              "classes": [
                                "nav__item"
                              ],
                              "children": {
                                "id": "1b3cb596-b551-402b-aa38-71b3a1afb070",
                                "data": [
                                  {
                                    "id": "67e30138-4822-43c1-a381-b10be39c8eec",
                                    "number": 0,
                                    "title": "Ссылка — Цены",
                                    "description": "Текст ссылки",
                                    "data": "ВК",
                                    "tag": "p",
                                    "classes": [
                                      "nav__link"
                                    ],
                                    "settings": {
                                      "cursor": "pointer",
                                      "padding": "0rem 0rem 0rem 0rem",
                                      "flexWrap": "nowrap",
                                      "justifyContent": "center",
                                      "alignItems": "center",
                                      "gap": "0.5rem",
                                      "responsive": {
                                        "480": {
                                          "fontSize": "1.5rem"
                                        },
                                        "768": {
                                          "fontSize": "1.5rem"
                                        },
                                        "1245": {}
                                      }
                                    },
                                    "children": {
                                      "id": "id-4mn7qdpbu",
                                      "data": [
                                        {
                                          "id": "id-e1fuype9d",
                                          "number": 0,
                                          "tag": "i",
                                          "title": "Иконка",
                                          "classes": [
                                            "icon",
                                            "fab fa-vk"
                                          ],
                                          "data": [],
                                          "settings": {}
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              "id": "055fd15a-b42e-45aa-8ae3-da7013f88151",
                              "number": 4,
                              "title": "Пункт меню — О нас",
                              "description": "Ссылка на страницу о салоне",
                              "data": "",
                              "tag": "p",
                              "classes": [
                                "nav__item"
                              ],
                              "children": {
                                "id": "9f7d7f26-5066-4ff2-9368-ed4978928a62",
                                "data": [
                                  {
                                    "id": "0b41c1c0-a434-48f2-82b6-abdaa5167394",
                                    "number": 0,
                                    "title": "Ссылка — О нас",
                                    "description": "Текст ссылки",
                                    "data": "Телега",
                                    "tag": "p",
                                    "classes": [
                                      "nav__link"
                                    ],
                                    "settings": {
                                      "flexWrap": "nowrap",
                                      "justifyContent": "center",
                                      "alignItems": "center",
                                      "gap": "0.5rem",
                                      "cursor": "pointer",
                                      "responsive": {
                                        "480": {
                                          "fontSize": "1.5rem"
                                        },
                                        "768": {
                                          "fontSize": "1.5rem"
                                        },
                                        "1245": {
                                          "flexDirection": "row",
                                          "alignItems": "center",
                                          "gap": "0.5rem"
                                        }
                                      }
                                    },
                                    "children": {
                                      "id": "id-c6olmzx0n",
                                      "data": [
                                        {
                                          "id": "id-tukio0lwr",
                                          "number": 0,
                                          "tag": "i",
                                          "title": "Иконка",
                                          "classes": [
                                            "icon",
                                            "fab fa-telegram"
                                          ],
                                          "data": [],
                                          "settings": {}
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        "id": "babs8fee-935d-4789-a067-6c0d8ff0a563",
                        "number": 3,
                        "title": "Контакты / телефон",
                        "description": "Телефон для быстрой связи",
                        "data": "",
                        "tag": "div",
                        "classes": [
                          "nav__phone"
                        ],
                        "children": {
                          "id": "ece39ff7-a2eb-4f07-a0c7-8a639ce5086b",
                          "data": [
                            {
                              "id": "babw8fv4-935d-4789-a067-6c0d8ff0a563",
                              "number": 3,
                              "title": "Контакты / телефон",
                              "description": "Телефон для быстрой связи",
                              "data": "+7 (999) 123-45-67",
                              "tag": "p",
                              "classes": [
                                "nav__phone"
                              ],
                              "settings": {
                                "marginLeft": "0",
                                "marginRight": "0.5rem",
                                "cursor": "pointer",
                                "responsive": {
                                  "480": {
                                    "fontSize": "1.5rem",
                                    "marginLeft": "0",
                                    "marginTop": "2rem",
                                    "marginRight": "0",
                                    "marginBottom": "1rem"
                                  },
                                  "768": {
                                    "fontSize": "1.5rem",
                                    "marginLeft": "0",
                                    "marginTop": "2rem",
                                    "marginRight": "0",
                                    "marginBottom": "1rem"
                                  },
                                  "1248": {
                                    "marginBottom": "1rem"
                                  }
                                }
                              }
                            },
                            {
                              "id": "0f5611g0-2f34-4bfc-9ded-fa183d2b7cef",
                              "number": 4,
                              "title": "CTA — Записаться",
                              "description": "Кнопка призыва к действию для записи на услугу",
                              "data": "Записаться",
                              "tag": "button",
                              "classes": [
                                "nav__cta",
                                "btn",
                                "btn--primary"
                              ],
                              "settings": {
                                "responsive": {
                                  "480": {},
                                  "768": {},
                                  "1245": {
                                    "margin": "0rem 0rem 0rem 0rem",
                                    "flexWrap": "nowrap",
                                    "flexDirection": "row",
                                    "justifyContent": "center",
                                    "alignItems": "center",
                                    "gap": "0.5rem",
                                    "padding": "0.5rem 1rem 0.5rem 1rem",
                                    "letterSpacing": 0,
                                    "lineHeight": 1,
                                    "fontSize": 1
                                  },
                                  "1248": {}
                                },
                                "flexDirection": "row"
                              },
                              "children": {
                                "id": "56109b2a-2035-4d74-b390-1cedef07c98b",
                                "data": [
                                  {
                                    "id": "c94ff921-14e2-449c-bf13-61ac8538d72c",
                                    "number": 1,
                                    "tag": "i",
                                    "title": "Иконка",
                                    "classes": [
                                      "icon",
                                      "far fa-calendar-alt"
                                    ],
                                    "data": [],
                                    "settings": {}
                                  }
                                ]
                              },
                              "action": {
                                "id": "26c7be7d-9b83-479f-b5ad-1c0fa1608bb9",
                                "name": "Открыть диаологовое окно",
                                "slug": "open-modal",
                                "functionName": "openModal",
                                "data": [
                                  {
                                    "type": "input",
                                    "id": "cd1r4930-abf2-40db-893c-591450f20055",
                                    "value": "Записаться на прием",
                                    "placeholder": "Заголовок",
                                    "label": "Заголовок"
                                  },
                                  {
                                    "type": "input",
                                    "id": "2a0c82g2-0c10-4181-8b59-8dcea0ffee08",
                                    "value": "Отмена",
                                    "placeholder": "Отмена",
                                    "label": "Кнопка"
                                  },
                                  {
                                    "type": "input",
                                    "id": "1vd4c44d-00dd-40c3-98fb-2f457ac89c72",
                                    "value": "Записаться",
                                    "placeholder": "Сохранить",
                                    "label": "Кнопка"
                                  },
                                  {
                                    "type": "p",
                                    "id": "4a3a1g5b-f210-4061-8f69-54ce1b131702",
                                    "value": "Укажите ваши данные",
                                    "label": "Параграф / описание",
                                    "placeholder": "Например - Ссылка на сайт"
                                  },
                                  {
                                    "type": "input",
                                    "id": "6de4ah80-ccb8-4bf0-98c0-80cee358aac6",
                                    "value": "ФИО",
                                    "placeholder": "Например - Укажите ваше ФИО",
                                    "label": "Текстовый ввод"
                                  },
                                  {
                                    "type": "p",
                                    "id": "ea70e210-h697-41bb-928e-9fa97e857953",
                                    "value": "Выберите дату для записи",
                                    "label": "Параграф / описание",
                                    "placeholder": "Например - Введите пароль"
                                  },
                                  {
                                    "type": "datetime",
                                    "id": "70508d6f-70td-4cec-9fac-e0b9f716b07f",
                                    "value": false,
                                    "label": "Выбор даты/времени",
                                    "placeholder": "Например - Дата рождения"
                                  },
                                  {
                                    "type": "p",
                                    "id": "4b77e403-2r33-47cb-874e-3680f99bc86c",
                                    "value": "Добавьте желаемый дизайн",
                                    "label": "Параграф / описание",
                                    "placeholder": "Например - Дата рождения"
                                  },
                                  {
                                    "type": "file",
                                    "id": "c174bw64-e39e-46cc-b1c4-112ab2f9a3b0",
                                    "value": "",
                                    "label": "Загрузка файлов",
                                    "placeholder": "Например - Дата рождения"
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    ]
  }
]